import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import {
  HistoryCallsUser,
  ReturningCallback,
  returnListCallQueue,
  InsertContactNew,
  getCep,
  SearchingHistoryCDR,
  SearchingHistoryData,
  ShowInfoDisplay,
  GetHistory,
  GetHistoryCalls,
  RequestActiveCall,
  dbfileSize,
  InterationNotifier,
  RequestActiveCallSocketVoz,
  AddNumberContact,
  GetPhoneMidia,
  GetTypeNumbers,
  GetNumbersContact,
  GetCompanys,
  ShowModalsMenu,
  GetContactsUnit,
  getNumbersContact,
  getPhoneMidia,
  infoContact,
  UpdateContactNumber,
  UpdateContact,
  deleteNumberContact,
  SearchingHistoryCDRVoz,
  GetInteractionsModal,
  GetDetailsContacts,
} from "../actions";
import ICONWZ from "../build/images/whatsapp.svg";
import ICONVOZ from "../build/images/voz_icon.svg";
import ICONFACE from "../build/images/facebook.svg";
import ICONWEBCHAT from "../build/images/webchat.svg";
import { Topover } from "../actions/Tippy";
import { Redirect } from "react-router-dom";
import FACEBOOK from "../build/images/channels/facebook.svg";
import WHATSAPP from "../build/images/channels/whatsapp.svg";
import INSTAGRAM from "../build/images/instagram_new.svg";
import INSTAGRAMLARGE from "../build/images/channelsNew/instagram.svg";
import WEBCHAT from "../build/images/webchat.svg";
import EMAIL from "../build/images/channels/email.svg";
import TWITTER from "../build/images/twitter-new.svg";
import MIDIAFACE from "../build/images/facebook_new.svg";
import MIDIAFACELARGE from "../build/images/channelsNew/facebook.svg";
//import MIDIAZAP from "../build/images/whatsapp_new.svg";
import { ReactComponent as SMSICON } from "../build/images/sms-new.svg";
import MIDIAZAP from "../build/images/icons-channels/whatsapp2-large.svg";
import MIDIAEMAIL from "../build/images/email-new.svg";
import MIDIAWEB from "../build/images/webchat-new.svg";
import CALLCHAT from "../build/images/callchat-new.svg";
import TELEGRAM from "../build/images/channels/telegram.svg";
import GOOGLEGBM from "../build/images/googlegbm-new.svg";
import GOOGLEGBMLARGE from "../build/images/icons-channels/googlegbm-large2.svg";
import MIDIATELEGRAM from "../build/images/telegram-new.svg";
import LINKEDIN from "../build/images/linkedin-new.svg";
import JPG from "../build/images/jpg-file.png";
import XLS from "../build/images/media-icon.png";
import PDF from "../build/images/pdf-file.png";
import MP3 from "../build/images/mp3-file.png";
import FLAG from "../build/images/flag-br.png";
import AVI from "../build/images/avi-file.png";
import PHONE from "../build/images/channels/voz-icon.svg";
import ICONPDFEXPORT from "../build/images/pdf.svg";
import Moment from "moment";
import "tippy.js/dist/tippy.css";
import "tippy.js/dist/themes/light.css";
import latinize from "latinize";
import { CSVLink } from "react-csv";
import MicroModal from "micromodal";
import Highlighter from "react-highlight-words";
import _ from "lodash";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import PdfDocument from "./templates/PdfDocument";
import "./templates/style.css";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import DEFAULT from "../build/images/default.png";
import CONTATOSALVO from "../build/images/adicionado.svg";
import Select from "react-select";
import InputMask from "react-input-mask";
import VIDEO from "../build/images/video.jpg";
import AUDIO from "../build/images/audio.svg";
import FOTO from "../build/images/foto.svg";
import DOC from "../build/images/doc.svg";
import ModalsDetails from "../components/modals/NewModals";
import Typography from "./Typography";
import UserPhoto from "./UserPhoto/userphoto";
import Audio from "./Audio/Audio";
import Loading from "./Loading";
import { ReactComponent as IconDownload } from "../build/images/image-modal/Document-download.svg";
import TEAMS from "../build/images/channels/teamsMedium.svg";
import { filtrarTroncosParaOHistorico } from "../utils/filtrarTroncosParaOHistorico";

const { connection_platform } = require("../services/api");
const { meses } = require("../services/data");

var options = [];
var typenumbers = [];
var companys = [];

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;
var checkreply = false;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  //if(parseInt(connection_platform.port_apache_view_extern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

function createJSON(item) {
  if (item) {
    var mensagem_tratada = item.replace(/¿/gi, "\n");
    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    let valor = 1;
    try {
      mensagem_tratada =
        '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
    } catch (e) {
      mensagem_tratada = item;
    }
    return mensagem_tratada;
  }
}

var active = true;
var arrayfix = [];

MicroModal.init();

var headers = [
  { label: "Mídia", key: "mediaid" },
  { label: "Data/Hora Inicio", key: "to_char" },
  { label: "Data/Hora Fim", key: "dateend" },
  { label: "Dur.Ring.", key: "ringduration" },
  { label: "Duração", key: "duration" },
  { label: "Nome", key: "contactname" },
  { label: "Chamado", key: "called" },
  { label: "Chamador", key: "caller" },
  { label: "Tipo", key: "directionin" },
  { label: "Situação", key: "answer" },
  { label: "Razão de desconexão", key: "razao_desc" },
  { label: "Agente", key: "displayname" },
  { label: "Estado", key: "status" },
  { label: "Protocolo", key: "protocolo" },
];

const mapStateToProps = (state) => {
  return {
    VerificarUser: state.informationusers,
    InfoUsers: state.informationusers,
    HistoryUser: state.historycalls,
    PermissionRouter: state.routergroups,
    OutBandService: state.outservices,
    StatusAgent: state.status,
    listCallQueue: state.listcallqueue,
    IPCurrent: state.ipcurrent,
    History: state.history,
    TypeNumbers: state.typenumbers,
    UsersAgents: state.agents,
    NumbersContact: state.numberscontact,
    Companys: state.companys,
    returnCep: state.cep,
    infoContact: state.infocontact,
    PhoneMidia: state.phonemidia,
    ContactId: state.atendimento,
  };
};

const mapDispatchToProps = (dispatch) => ({
  HistoryCallsUserIda: (
    datainit,
    datafim,
    chamador,
    chamado,
    naoatendidas,
    ocupado,
    saida,
    entrada,
    ring,
    atendidas,
    livre,
    midias,
    mensagem,
    finalizadas,
  ) => {
    dispatch(
      HistoryCallsUser(
        datainit,
        datafim,
        chamador,
        chamado,
        naoatendidas,
        ocupado,
        saida,
        entrada,
        ring,
        atendidas,
        livre,
        midias,
        mensagem,
        finalizadas,
      ),
    );
  },
  UpdateContactNumber: (number, iduser, contactid) => {
    dispatch(UpdateContactNumber(number, iduser, contactid));
  },
  UpdateContact: (
    contactid,
    displayname,
    name,
    email,
    cpf,
    rg,
    codigoexterno,
    nascimento,
    endereco,
    numero,
    district,
    cepassociationid,
    numberdel,
    particular,
  ) => {
    dispatch(
      UpdateContact(
        contactid,
        displayname,
        name,
        email,
        cpf,
        rg,
        codigoexterno,
        nascimento,
        endereco,
        numero,
        district,
        cepassociationid,
        numberdel,
        particular,
      ),
    );
    dispatch(deleteNumberContact(numberdel));
  },
  SearchingHistoryCDR: (telefone, cdrid, idggroup, infouser) => {
    SearchingHistoryCDR(telefone, cdrid, idggroup, infouser)(dispatch);
  },
  SearchingHistoryCDRVoz: (telefone, cdrid, idggroup) => {
    SearchingHistoryCDRVoz(telefone, cdrid, idggroup)(dispatch);
  },
  SearchingHistory: (histstart, histend, idatendimento, telefone, idgroup) => {
    dispatch(
      SearchingHistoryData(
        histstart,
        histend,
        idatendimento,
        telefone,
        idgroup,
      ),
    );
  },
  ReturningCallbackIn: (
    queueid,
    inforetorno,
    recvcount,
    cdrid,
    mediaid,
    srvin,
    caller,
    called,
    cbackcount,
  ) => {
    ReturningCallback(
      queueid,
      inforetorno,
      recvcount,
      cdrid,
      mediaid,
      srvin,
      caller,
      called,
    )(dispatch);
    dispatch(returnListCallQueue("", queueid, "2", parseInt(cbackcount + 1)));
  },
  ShowInfoDisplay: (post) => {
    dispatch(ShowInfoDisplay(post));
  },
  ClearHistory: (post) => {
    dispatch(GetHistory([]));
  },
  RequestActiveCall: (
    outband,
    infouser,
    trunk,
    mediaid,
    calledDigitado,
    addtech,
    scriptrunk,
    operator,
    returning,
    queueid,
    recvcount,
    cbackcount,
    idgrupo_transb,
    cdrold,
  ) => {
    dispatch(
      RequestActiveCall(
        outband,
        infouser,
        trunk,
        mediaid,
        calledDigitado,
        addtech,
        scriptrunk,
        operator,
        returning,
        queueid,
        recvcount,
        cbackcount,
        idgrupo_transb,
        cdrold,
      ),
    );
  },
  InterationNotifier: (text, type) => {
    dispatch(InterationNotifier(text, type));
  },
  AddNumberContact: (post, number) => {
    dispatch(AddNumberContact(post, number));
    dispatch(GetPhoneMidia([]));
    dispatch(GetTypeNumbers());
    dispatch(GetCompanys(post));
  },
  ClearNumbersContact: (post) => {
    dispatch(GetNumbersContact([]));
  },
  GetNumbersContact: (post) => {
    dispatch(getNumbersContact(post));
    dispatch(getPhoneMidia(post));
    dispatch(GetTypeNumbers(post));
  },
  RequestActiveCallSocketVoz: (
    outband,
    infouser,
    trunk,
    mediaid,
    chamado,
    addtech,
    scriptrunk,
    operator,
    returning,
    queueid,
    recvcount,
    callback_count,
    tech,
    idgrupo_rota,
    idgrupo_transb,
    ipcurrent,
    cdrid,
    rotaencontrada,
  ) => {
    dispatch(
      RequestActiveCallSocketVoz(
        outband,
        infouser,
        trunk,
        mediaid,
        chamado,
        addtech,
        scriptrunk,
        operator,
        returning,
        queueid,
        recvcount,
        callback_count,
        tech,
        idgrupo_rota,
        idgrupo_transb,
        ipcurrent,
        cdrid,
        rotaencontrada,
      ),
    );
  },
  AddNumberContact: (post, number) => {
    dispatch(AddNumberContact(post, number));
    dispatch(GetPhoneMidia([]));
  },
  getCep: (post) => {
    dispatch(getCep(post));
  },
  InsertContactNew: (
    displayname,
    name,
    email,
    cpf,
    rg,
    codigoexterno,
    nascimento,
    endereco,
    numero,
    district,
    cepassociationid,
    particular,
    usercreate,
    numberscontact,
    contatode,
    empresa,
  ) => {
    dispatch(
      InsertContactNew(
        displayname,
        name,
        email,
        cpf,
        rg,
        codigoexterno,
        nascimento,
        endereco,
        numero,
        district,
        cepassociationid,
        particular,
        usercreate,
        numberscontact,
        contatode,
        empresa,
        "history",
      ),
    );
  },
  ShowModalsMenu: (post) => {
    dispatch(ShowModalsMenu(post));
  },
  GetContactsUnit: (post) => {
    dispatch(GetContactsUnit(post));
  },
  clearInfoContact: (post) => {
    dispatch(infoContact([]));
  },
  GetInteractionsModal: (client, number) => {
    dispatch(GetInteractionsModal(client, number));
  },
  GetDetailsContacts: (value, data, datacontact) => {
    dispatch(GetDetailsContacts(value, data, datacontact));
  },
});

function isJson(item) {
  item = typeof item != "string" ? JSON.stringify(item) : item;

  try {
    item = JSON.parse(item);
  } catch (e) {
    return false;
  }

  if (typeof item === "object" && item != null) {
    return true;
  }

  return false;
}

function tratarMSG(item) {
  var mensagem_tratada = item;
  mensagem_tratada = item.replace(/¿/gi, "\n");
  mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
  let valor = 1;
  try {
    mensagem_tratada =
      '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
    var obj = JSON.parse(mensagem_tratada);
    mensagem_tratada = obj[1][0].mensagem_tratada;
  } catch (e) {
    mensagem_tratada = item;
    mensagem_tratada = mensagem_tratada.replace(/\r\n/gi, "ªª");
    mensagem_tratada = mensagem_tratada.replace(/\r\n/gi, "ªª");
    mensagem_tratada = mensagem_tratada.replace(/"/gi, "");
    mensagem_tratada = mensagem_tratada.replace(
      /[^A-ZÀ-Ú a-zà-ú 0-9 , . ? ! *  # ; : '-' _ + § ¿ { } ' " ª \\ \ ]/g,
      "",
    );
    mensagem_tratada =
      '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
    try {
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
      mensagem_tratada = mensagem_tratada.replace(/ªª/gi, "\r\n");
    } catch (e) {
      mensagem_tratada = item;
    }
  }
  return mensagem_tratada;
}

class Historic extends Component {
  pdfExportComponent;
  constructor(props) {
    var buttondateinit =
      localStorage.getItem("button_historic_dateinit") || true;
    var buttondateend = localStorage.getItem("button_historic_dateend") || true;
    var buttonchamador =
      localStorage.getItem("button_historic_chamador") || true;
    var buttonchamado = localStorage.getItem("button_historic_chamado") || true;
    var buttonnoanswer =
      localStorage.getItem("button_historic_noanswer") || true;
    var buttonanswer = localStorage.getItem("button_historic_answer") || true;
    var buttonentry = localStorage.getItem("button_historic_entry") || true;
    var buttonexit = localStorage.getItem("button_historic_exit") || true;
    var buttonfinalizadas =
      localStorage.getItem("button_historic_finalizadas") || true;
    var buttonclient_desconnection =
      localStorage.getItem("button_historic_client_desconnection") || true;
    var buttonring = localStorage.getItem("button_historic_ring") || true;
    var buttontext = localStorage.getItem("button_historic_text") || true;
    var buttonmidia = localStorage.getItem("button_historic_midia") || true;
    var storageMidias = localStorage.getItem("button_historic_midias") || [];

    if (storageMidias.length !== 0) {
      storageMidias = storageMidias.split(",").map(Number);
    }
    super(props);
    this.state = {
      ButtonShowMidia: buttonmidia === "false" ? false : true,
      ButtonShowText: buttontext === "false" ? false : true,
      ButtonShowClientDesconnection:
        buttonclient_desconnection === "false" ? false : true,
      ButtonShowExit: buttonexit === "false" ? false : true,
      ButtonShowFinalizadas: buttonfinalizadas === "false" ? false : true,
      ButtonShowEntry: buttonentry === "false" ? false : true,
      ButtonShowAnswer: buttonanswer === "false" ? false : true,
      buttonShowRing: buttonring === "false" ? false : true,
      buttonShowNoAnswer: buttonnoanswer === "false" ? false : true,
      buttonShowChamador: buttonchamador === "false" ? false : true,
      buttonShowChamado: buttonchamado === "false" ? false : true,
      buttonShowDateFim: buttondateend === "false" ? false : true,
      numberscontact: [],
      buttonshowpfpj: false,
      searchText: "",
      buttonShowDateInit: buttondateinit === "false" ? false : true,
      shown: true,
      historyUser: [],
      disablebutton: false,
      totalRegistros: 0,
      buttonFixRegister: false,
      expandRegister: [],
      contRegister: 0,
      MidiasId: storageMidias,
      RegisterFix: [],
      senhaincorreta: "none",
      redirect: false,
      cliente: "Nenhum",
      cdrid: 0,
      sort: [{ info: "to_char", action: true }],
      auxsort: "mediaid",
      sortName: "to_char",
      sortActive: false,
      history: [],
      ordemSort: "cres",
      buttonPalavraText: true,
      mensagem: "",
      loading: false,
      empresa: "",
      private: null,
      numberDel: [],
      modalInfos: {},
    };
    this.SearchHistory = this.SearchHistory.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }

  SearchHistory(idatendimento) {
    let telefone = "99999999";
    if (arrayfix.length != 0) {
      telefone = arrayfix[0].chamador;
    }
    let histstart = document.getElementById("hist_start").value;
    let histend = document.getElementById("hist_end").value;
    this.setState({ datapdfinit: histstart, datapdfend: histend });
    let idgroup = this.props.InfoUsers.idgroup;
    this.props.SearchingHistory(histstart, histend, 33, telefone, idgroup);
  }

  handleKeyUp(inf) {
    var elems = document.getElementsByTagName("mark");
    var tam = elems.length;

    if (tam >= this.state.arrowterm + 1) {
      elems[this.state.arrowterm].scrollIntoView(false);
      if (inf == "less") {
        if (this.state.arrowterm != 0) {
          this.state.arrowterm = this.state.arrowterm - 1;
        }
      } else {
        this.state.arrowterm = this.state.arrowterm + 1;
      }
    } else {
      if (elems[this.state.arrowterm]) {
        this.state.arrowterm = 0;
        elems[this.state.arrowterm].scrollIntoView(false);
      }
    }
  }

  renderPopoverPhoto = (e, ip, file) => (
    <>
      {file ? (
        <div className="img">
          <img
            src={
              file ? connection_platform.type_connect + "://" + ip + file : null
            }
            width="100"
            alt=""
          />
        </div>
      ) : (
        ""
      )}
    </>
  );

  AddNumber(e) {
    this.props.AddNumberContact();
  }

  buttonSearchUserHistory(e) {
    e.preventDefault();
    this.setState({ historyUser: [] });

    this.setState({ disablebutton: true });

    var erro = 0;
    const datainit = this.dataInit.value;
    const datafim = this.dataFim.value;
    const chamador = this.chamador.value;
    const chamado = this.chamado.value;
    const naoatendidas = this.naoatendidas.checked;
    const saida = this.saida.checked;
    const ring = this.ring.value;
    const entrada = this.entrada.checked;
    const atendidas = this.atendidas.checked;
    const ocupado = this.ocupado.checked;
    const livre = this.livre.checked;
    const finalizadas = this.finalizadas.checked;

    //const desconexao   = this.desconexao.checked;
    var midias = "";

    var comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (this.state.MidiasId.length != 0) {
      var midias = this.state.MidiasId.toString();
    }

    if (erro === 0) {
      this.props.HistoryCallsUserIda(
        datainit,
        datafim,
        chamador,
        chamado,
        naoatendidas,
        ocupado,
        saida,
        entrada,
        ring,
        atendidas,
        livre,
        midias,
        this.state.mensagem,
        finalizadas,
      );
    }
    active = true;

    setTimeout(
      function () {
        this.setState({ disablebutton: false });
      }.bind(this),
      5500,
    );
  }

  SearchInHistory(e) {
    e.preventDefault();
    this.setState({ showHistory: !this.state.showHistory });
  }

  filterMidia(e, idmidia) {
    let filtermidiastorage = [];
    if (e.target.checked) {
      this.setState({
        MidiasId: this.state.MidiasId.concat([idmidia]),
      });
      filtermidiastorage = this.state.MidiasId.concat([idmidia]);
    } else {
      this.setState({
        MidiasId: this.state.MidiasId.filter(function (val) {
          return val != idmidia;
        }),
      });
      filtermidiastorage = this.state.MidiasId.filter(function (val) {
        return val != idmidia;
      });
    }
    localStorage.setItem("button_historic_midias", filtermidiastorage);
  }

  sortByName(event, sortName, By) {
    var sort = "";
    if (By === "cres") {
      sort = "desc";
      this.setState({ ordemSort: "dec" });
    } else {
      sort = "asc";
      this.setState({ ordemSort: "cres" });
    }

    var chars = this.state.historyUser;

    chars = _.orderBy(chars, [sortName], [sort]); // Use Lodash to sort array by 'name'

    this.setState({ historyUser: chars, sortName: sortName });
  }

  checkFixRegister(
    e,
    idregister,
    chamador,
    cdrid,
    chamado,
    direction,
    midia,
    datahora,
    contactname,
    contactid,
    idtrunk,
  ) {
    arrayfix = [];
    this.setState({
      expandRegister: idregister,
    });
    if (direction === 2) {
      arrayfix = [
        {
          chamador: chamado,
          cdrid: cdrid,
          midia: midia,
          contactname: contactname,
          contactid: contactid,
          idtrunk: idtrunk,
        },
      ];
      this.setState({
        RegisterFix: arrayfix,
        clientpdf: chamado,
        datepdf: datahora,
      });
    } else {
      //chamador = chamador.replace(/\D+/g, "");
      arrayfix = [
        {
          chamador: chamador,
          cdrid: cdrid,
          midia: midia,
          direction: direction,
          contactname: contactname,
          contactid: contactid,
          idtrunk: idtrunk,
        },
      ];
      this.setState({
        RegisterFix: arrayfix,
        clientpdf: chamador,
        datepdf: datahora,
      });
    }
    this.props.ClearHistory();
    var formatted = Moment(datahora, "DD/MM/YYYY HH:mm:ss").format(
      "YYYY-MM-DD",
    );
    document.getElementById("hist_start").value = formatted + "T00:00";
    document.getElementById("hist_end").value = formatted + "T23:59";
    this.setState({
      datapdfinit: formatted + "T00:00",
      datapdfend: formatted + "T23:59",
    });
    if (contactid != null) {
      this.props.GetContactsUnit(contactid);
    } else {
      this.props.clearInfoContact();
    }
  }

  SolicitarChamadaAtiva(
    e,
    permrouter,
    outband,
    infouser,
    callStatus,
    queue,
    ipcurrent,
    statusAgent,
  ) {
    try {
      document.getElementById("div_alert").innerHTML = "";

      if (this.props.ContactId.length !== 0) {
        localStorage.setItem(
          "current-service",
          this.props.ContactId.idatendimento,
        );
      }

      if (!statusAgent.allowCall) {
        this.props.InterationNotifier("Pausa não permite ativo", "permission");
        return true;
      }

      const chatMessage = document.getElementById("chat-message");
      if (chatMessage) chatMessage.innerText = "";

      if (!permrouter || permrouter.length === 0) return;

      if (arrayfix.length != 0) {
        var chamado = arrayfix[0].chamador;
        var mediaid = arrayfix[0].midia;
      }
      const rawNumber = chamado;
      let tipochamada = 0;
      let DDD = permrouter[0].areacodeid || "71";

      const valorfixo = [1, 2, 3, 4],
        valormovel = [5, 6, 7, 8, 9];
      const removeDigits =
        connection_platform.remove_digits || parseInt(mediaid) !== 1;

      if (
        removeDigits &&
        chamado.startsWith("0") &&
        !chamado.startsWith("00") &&
        !chamado.startsWith("0800")
      ) {
        chamado = chamado.substring(1);
      }

      function definirTipoChamada(mediaid, tipo) {
        const tipos = {
          fixoInterurbano: [3, 17, 19, 18, 20, 21, 23, 22, 24, 25],
          movelInterurbano: [4, 17, 19, 18, 20, 21, 23, 22, 13, 24, 25],
          fixoLocal: [1, 17, 19, 18, 20, 21, 23, 22, 24, 25],
          movelLocal: [2, 17, 19, 18, 20, 21, 23, 22, 13, 24, 25],
        };

        // Converte mediaid para inteiro
        const midiaConvertida = parseInt(mediaid, 10);

        // Se mediaid for 1, busca no objeto `tipos`, senão segue a lógica específica
        if (midiaConvertida === 1) {
          return tipos[tipo] ? tipos[tipo][midiaConvertida - 1] || 0 : 0;
        } else {
          const mapeamentoMidia = {
            2: 24,
            3: 22,
            4: 18,
            5: 17,
            6: 20,
            8: 19,
            9: 21,
            10: 23,
            12: 13,
            15: 26,
          };

          return mapeamentoMidia[midiaConvertida] || midiaConvertida;
        }
      }

      if (
        (chamado.length >= 10 ||
          chamado.length === 8 ||
          chamado.length === 9) &&
        !chamado.startsWith("00")
      ) {
        if (
          chamado.startsWith("55") &&
          (mediaid === 5 || mediaid === "5") &&
          chamado.length > 11
        )
          chamado = chamado.substr(2);
        if (chamado.length === 8 || chamado.length === 9)
          chamado = DDD + chamado;
      }

      let chamadoValidado = chamado.replace(/^0(?!0|800|300)/, "");
      console.log("INGENIUM_ACTVECALL_0 : ", chamado);

      let dddValidado =
        chamadoValidado.length >= 10 ? chamadoValidado.substr(0, 2) : "";

      console.log("INGENIUM_ACTVECALL_0 : ", chamadoValidado);

      if (
        chamadoValidado.length >= 10 &&
        !chamadoValidado.startsWith("00") &&
        !chamadoValidado.startsWith("0800")
      ) {
        if (valorfixo.includes(parseInt(chamadoValidado[2]))) {
          tipochamada = definirTipoChamada(
            mediaid,
            dddValidado && parseInt(dddValidado) !== parseInt(DDD)
              ? "fixoInterurbano"
              : "fixoLocal",
          );
        } else if (valormovel.includes(parseInt(chamadoValidado[2]))) {
          tipochamada = definirTipoChamada(
            mediaid,
            dddValidado && parseInt(dddValidado) !== parseInt(DDD)
              ? "movelInterurbano"
              : "movelLocal",
          );
        }
      } else if (chamadoValidado.startsWith("0800")) {
        tipochamada = 8;
      } else if (chamadoValidado.startsWith("00")) {
        tipochamada = 5;
      } else {
      }

      console.log("INGENIUM_ACTVECALL_1 : ", tipochamada);

      // function buscarRota() {
      //     let rota = null;

      //     console.log("INGENIUM_ACTVECALL_1 : ",permrouter)

      //     permrouter.forEach(result => {

      //         if (result.calltypeid === tipochamada && parseInt(result.idmidia) === parseInt(mediaid)) {
      //             rota = result;
      //         }
      //     });
      //     return rota;
      // }

      function buscarRota() {
        let rota = [];

        console.log("INGENIUM_ACTVECALL_1 : ", permrouter);

        const doisPrimeirosDigitos = chamadoValidado.substring(0, 2);

        // Só verifica `areacode` se `mediaid` for 1
        const verificarAreacode = parseInt(mediaid) === 1;
        const verificarWhatsappInternacional = parseInt(mediaid) === 5;

        // Verifica se existe pelo menos um item com areacode correspondente (somente se `mediaid` for 1)
        const existeAreaCode = verificarAreacode
          ? permrouter.some(
              (result) =>
                result.areacode &&
                String(result.areacode).startsWith(doisPrimeirosDigitos),
            )
          : false;

        permrouter.forEach((result) => {
          if (
            result.calltypeid === tipochamada &&
            parseInt(result.idmidia) === parseInt(mediaid) &&
            (!verificarAreacode ||
              !existeAreaCode ||
              (result.areacode &&
                String(result.areacode).startsWith(doisPrimeirosDigitos)))
          ) {
            rota.push(result);
          }
          if (result.calltypeid === 11 && rota.length === 0) {
            if (
              parseInt(chamado) >= parseInt(result.partialnumber) &&
              parseInt(chamado) <= parseInt(result.partialnumber_end)
            ) {
              rota.push(result);
            }
          } else if (result.calltypeid === 6 && rota.length === 0) {
            if (parseInt(chamado) === parseInt(result.partialnumber)) {
              rota.push(result);
            }
          } else if (
            tipochamada === 5 &&
            mediaid === 5 &&
            result.calltypeid === 17
          ) {
            rota.push(result);
            chamado = chamado.replace(/^00/, "");
          }
        });

        console.log("INGENIUM_ACTVECALL_1222222 : ", rota);

        if (rota && rota.length > 1) {
          let isExistOther = false;
          rota.forEach((result) => {
            const lastEight = String(chamado).slice(-8);
            if (
              parseInt(lastEight) >= parseInt(result.partialnumber) &&
              parseInt(lastEight) <= parseInt(result.partialnumber_end)
            ) {
              rota = result;
              isExistOther = true;
            }
          });
          if (!isExistOther) {
            rota = rota.filter((temp) => temp.isdefault === "t");
            rota = rota.length !== 0 ? rota[0] : [];
          }
        } else if (rota.length === 1) {
          rota = rota[0];
        }

        return rota;
      }

      const rotaEncontrada = buscarRota();

      console.log("INGENIUMACTIVECALL", rotaEncontrada);

      if (rotaEncontrada.length === 0) {
        this.setState({ senhaincorreta: "block" });
        document.getElementById("div_alert").innerHTML = "Sem rota de saída!";
        return;
      }

      let retorno = 0;
      // let queueData = queue.find(q => q.caller.includes(chamado));
      let queueData = queue.find(
        (q) => q.caller.includes(chamado) && q.mediaid === mediaid,
      );
      if (queueData) {
        retorno = 1;
      }

      let queueid = queueData && queueData.queueid ? queueData.queueid : null;
      let recvcount =
        queueData && queueData.recvcount ? queueData.recvcount : null;
      let cdrid = queueData && queueData.cdrid ? queueData.cdrid : null;
      let srvin =
        queueData && queueData.serviceinid ? queueData.serviceinid : null;
      let caller = queueData && queueData.caller ? queueData.caller : null;
      let called = queueData && queueData.called ? queueData.called : null;
      let cbackcount =
        queueData && queueData.callback_count ? queueData.callback_count : null;
      let queueStatus =
        queueData && queueData.queueStatus ? queueData.queueStatus : null;
      let tech = rotaEncontrada.tech;
      let idgrupo_rota = rotaEncontrada.idgrupo_rota;
      let idgrupo_transb = rotaEncontrada.idgrupo_transb;
      let checkRota = true;

      if (mediaid === 5 || mediaid === 8) {
        chamado = chamado.trim();
      }

      if (mediaid === 1) {
        if (retorno === 1) {
          this.props.RequestActiveCallSocketVoz(
            outband,
            infouser,
            rotaEncontrada.idtrunk,
            mediaid,
            chamado,
            rotaEncontrada.addtech,
            rotaEncontrada.scripttrunk,
            rotaEncontrada.operator,
            true,
            queueid,
            recvcount,
            null,
            tech,
            idgrupo_rota,
            idgrupo_transb,
            ipcurrent,
            cdrid,
            checkRota,
          );
          this.props.ReturningCallbackIn(
            queueid,
            true,
            recvcount,
            cdrid,
            mediaid,
            srvin,
            caller,
            called,
            cbackcount,
            queueStatus,
          );
        } else {
          this.props.RequestActiveCallSocketVoz(
            outband,
            infouser,
            rotaEncontrada.idtrunk,
            mediaid,
            chamado,
            rotaEncontrada.addtech,
            rotaEncontrada.scripttrunk,
            rotaEncontrada.operator,
            false,
            queueid,
            recvcount,
            null,
            tech,
            idgrupo_rota,
            idgrupo_transb,
            ipcurrent,
            cdrid,
            checkRota,
          );
          this.props.ReturningCallbackIn(
            queueid,
            true,
            recvcount,
            cdrid,
            mediaid,
            srvin,
            caller,
            called,
            cbackcount,
            queueStatus,
          );
        }
      } else {
        if (retorno === 1) {
          this.props.RequestActiveCall(
            outband,
            infouser,
            rotaEncontrada.idtrunk,
            mediaid,
            chamado,
            rotaEncontrada.addtech,
            rotaEncontrada.scripttrunk,
            rotaEncontrada.operator,
            true,
            queueid,
            recvcount,
            cbackcount,
            idgrupo_transb,
            cdrid,
            rawNumber,
          );
          this.props.ReturningCallbackIn(
            queueid,
            true,
            recvcount,
            cdrid,
            mediaid,
            srvin,
            caller,
            called,
            cbackcount,
            queueStatus,
          );
        } else {
          this.props.RequestActiveCall(
            outband,
            infouser,
            rotaEncontrada.idtrunk,
            mediaid,
            chamado,
            rotaEncontrada.addtech,
            rotaEncontrada.scripttrunk,
            rotaEncontrada.operator,
            false,
            queueid,
            recvcount,
            cbackcount,
            idgrupo_transb,
            undefined,
            rawNumber,
          );
        }
      }

      this.props.ShowInfoDisplay("Clientes");
      // this.props.ShowActiveCallIn("");
      // MicroModal.close("modal__falar-com-cliente");
      // this.numberToActive.value = "";
    } catch (error) {
      console.log("SolicitarChamadaAtiva Error: ", error);
    }
  }

  DisplayModalHistory(e, display) {
    if (this.state.RegisterFix.length != 0) {
      var arrayfix = this.state.RegisterFix;
      var telefone = arrayfix[0].chamador;
      var cdrid = arrayfix[0].cdrid;
      var midia = arrayfix[0].midia;
      let idgroup = this.props.InfoUsers.idgroup;
      //Função que seta o nome e o número do contato pro modal de interações
      this.props.GetInteractionsModal(
        arrayfix[0].contactname,
        arrayfix[0].chamador,
      );
      //

      if (midia != 1) {
        // MicroModal.show("modal__historico-atendimento");
        MicroModal.show("modal__historico-atendimento-contact-2");
        this.props.SearchingHistoryCDR(
          telefone,
          cdrid,
          idgroup,
          this.props.InfoUsers,
        );
      } else if (midia == 1) {
        MicroModal.show("modal__interacao-voz");
        this.props.SearchingHistoryCDRVoz(telefone, cdrid, idgroup);
      }
    }
  }

  VerifierImage(e, urlimage, modal) {
    this.setState({ isOpen: true, urlimage: urlimage });
    if (modal === "history") {
      MicroModal.close("modal__historico-atendimento");
    }
    if (modal === "dmark") {
      MicroModal.close("modal__mensagens-favoritas");
    }
  }

  CloseImage(e, modal) {
    this.setState({ isOpen: false, urlimage: "" });
    if (modal === "history") {
      MicroModal.show("modal__historico-atendimento");
    }
    if (modal === "dmark") {
      MicroModal.show("modal__mensagens-favoritas");
    }
  }

  InsertContactOfHistory(e, user) {
    if (this.state.RegisterFix.length != 0) {
      var arrayfix = this.state.RegisterFix;
      var contactid = arrayfix[0].contactid;
      this.clearValues();
      if (contactid === null) {
        MicroModal.show("modal__agenda-pf-usuario-detalhes-history");
        this.props.AddNumberContact("post", arrayfix[0].chamador);
        var value = [{ value: user.id, label: user.username }];
        this.setState({ contatode: value });
      }
    } else {
    }
  }

  ChangeDisplayname = (e) => {
    this.displayname.value = e.target.value;
  };

  SelectContato(e) {
    if (e != null) {
      var value = [{ value: e.value, label: e.label }];
      this.setState({ contatode: value });
    } else {
      this.setState({ empresaC: "" });
    }
  }

  ContactPrivate(valor) {
    this.setState({ private: valor });
  }

  CancelMenosCampos(e, modal) {
    MicroModal.close("modal__agenda-pf-usuario-detalhes-history");
    this.props.ClearNumbersContact();
  }

  ShowModal(e, modal, contact, edit, number) {
    switch (modal) {
      case "modal__agenda-pf-usuario-detalhes":
        this.setState({ person: contact.displayname });
        this.setState({ numberC: contact.number, pathfile: contact.pathfile });
        MicroModal.close("modal__agenda");
        MicroModal.show("modal__agenda-pf-usuario-detalhes");
        this.props.ShowModalsMenu(modal);
        this.name.value = contact.name;
        this.checkValues(contact);
        var value = [{ value: contact.user_create, label: contact.username }];
        this.setState({ contatode: value });
        if (contact.idempresa) {
          var value = [{ value: contact.idempresa, label: contact.empresa }];
          this.setState({ empresaC: value, auxEmpresa: contact.idempresa });
        } else {
          this.setState({ empresaC: null });
          this.setState({ auxEmpresa: "" });
        }
        this.setState({ contactid: contact.id });
        this.setState({ private: contact.userid });
        if (edit) {
          this.setState({ disabled: true });
        } else {
          this.setState({ disabled: false });
        }
        this.props.GetNumbersContact(contact.id);
        break;
      case "modal__agenda-pf-usuario-detalhes-mais-campos-history":
        MicroModal.close("modal__agenda-pf-usuario-detalhes-history");
        MicroModal.show(
          "modal__agenda-pf-usuario-detalhes-mais-campos-history",
        );
        break;
      case "modal_contato_salvo":
        this.props.ShowModalsMenu(modal);
        MicroModal.close("modal__agenda-pj-empresa-detalhes-editar-salvo");
        MicroModal.show("modal__agenda");
        break;
      default:
        break;
    }
  }

  getCep(e) {
    var cep = this.cep.value;
    this.props.getCep(cep);
  }

  SelectEmpresa(e) {
    if (e != null) {
      var value = [{ value: e.value, label: e.label }];
      this.setState({ empresaC: value });
    } else {
      this.setState({ empresaC: "" });
    }
  }

  ShowModalMaisCampos(e, modal) {
    MicroModal.close("modal__agenda-pf-usuario-detalhes-mais-campos-history");
    MicroModal.show("modal__agenda-pf-usuario-detalhes-history");
  }

  CancelMaisCampos(e, modal) {
    MicroModal.close("modal__agenda-pf-usuario-detalhes-mais-campos-history");
  }

  InsertContact(e, numberscontact, usercreate) {
    var oDivAlerta1 = document.getElementById("msg_erro7");
    var oDivAlerta2 = document.getElementById("msg_erro8");
    var oDivAlerta3 = document.getElementById("msg_erro9");
    var erro = 0;
    var displayname = this.displayname.value;
    var name = this.name.value;
    var email = this.email.value;
    var contatode = this.state.contatode;
    contatode = contatode[0].value;
    var codigoexterno = this.codigoexterno.value;
    var particular = this.state.private;
    var nascimento = this.nascimento.value;
    var rg = this.rg.value;
    var cpf = this.cpf.value;
    var numero = this.numberaddress.value;
    var endereco = this.endereco.value;
    var cepassociationid = this.cepassociationid.value;
    var district = "";
    var empresa = this.state.empresa;
    //var numberdel        = this.state.numberDel;

    if (endereco != "") {
      var address = endereco.split(",");
      endereco = address[0];
      district = address[1];
    }

    if (name === "") {
      erro = 1;
      oDivAlerta1.style.display = "block";
      oDivAlerta1.innerHTML = "Preenchimento obrigatório";
    }
    if (contatode === "") {
      erro = 1;
      oDivAlerta3.style.display = "block";
      oDivAlerta3.innerHTML = "Preenchimento obrigatório";
    }
    if (displayname === "") {
      erro = 1;
      oDivAlerta2.style.display = "block";
      oDivAlerta2.innerHTML = "Preenchimento obrigatório";
    }

    if (erro === 0) {
      this.props.InsertContactNew(
        displayname,
        name,
        email,
        cpf,
        rg,
        codigoexterno,
        nascimento,
        endereco,
        numero,
        district,
        cepassociationid,
        particular,
        usercreate,
        numberscontact,
        contatode,
        empresa,
      );
      document.getElementById("nome").value = name;
      MicroModal.close("modal__agenda-pf-empresa-detalhes-history");
      MicroModal.show("modal__agenda-pj-empresa-detalhes-editar-salvo-history");
      this.setState({
        buttonnewcontact: !this.state.buttonnewcontact,
        disabled: false,
        module: "edit",
      });
      this.displayname.value = "";
      this.name.value = "";
      this.email.value = "";
    }
  }

  fillCep(location) {
    if (location.length != 0) {
      this.endereco.value = location[0].adress + ", " + location[0].district;
      this.cidade.value = location[0].city;
      this.estado.value = location[0].uf;
      this.cepassociationid.value = location[0].addressid;
    } else {
      this.endereco.value = "";
      this.cidade.value = "";
      this.estado.value = "";
      this.numberaddress.value = "";
    }
  }

  CloseModalSalvo(e) {
    MicroModal.close("modal__agenda-pj-empresa-detalhes-editar-salvo-history");
    document.getElementById("button_pesquisar").click();
    this.props.ClearNumbersContact();
  }

  FindContact(e, post) {
    MicroModal.close("modal__agenda-pj-empresa-detalhes-editar-salvo-history");
    document.getElementById("button_pesquisar").click();
    this.props.ShowModalsMenu(post);
  }

  ChangeInfoContact(e, info) {
    if (info.infocontact.length != 0) {
      let contact = info.infocontact;
      if (this.state.RegisterFix.length != 0) {
        this.props.GetDetailsContacts(true, contact);

        // this.setState({ person: contact.displayname });
        // this.setState({ numberC: contact.number, pathfile: contact.pathfile });
        // MicroModal.show("modal__agenda-pf-usuario-detalhes-history");
        // this.name.value = contact.name;
        // this.checkValues(contact);
        // var value = [{ value: contact.user_create, label: contact.username }];
        // this.setState({ contatode: value });
        // if (contact.idempresa) {
        //   var value = [{ value: contact.idempresa, label: contact.empresa }];
        //   this.setState({ empresaC: value, auxEmpresa: contact.idempresa });
        // } else {
        //   this.setState({ empresaC: null });
        //   this.setState({ auxEmpresa: "" });
        // }
        // this.setState({ contactid: contact.id });
        // this.setState({ private: contact.userid });
        // this.setState({ disabled: true });
        // this.props.GetNumbersContact(contact.id);
      }
    }
  }

  checkValues(contact) {
    if (contact.email === null || contact.email === "undefined") {
      this.email.value = "";
    } else {
      this.email.value = contact.email;
    }
    if (contact.displayname === null) {
      this.displayname.value = "";
    } else {
      this.displayname.value = contact.displayname;
    }
    if (contact.cepassociationid === null) {
      this.cepassociationid.value = "";
    } else {
      this.cepassociationid.value = contact.cepassociationid;
    }
    if (contact.codigoexterno === null) {
      this.codigoexterno.value = "";
    } else {
      this.codigoexterno.value = contact.externcode;
    }
    if (contact.cep === null) {
      this.cep.value = "";
    } else {
      this.cep.value = contact.cep;
    }
    if (contact.estado === null) {
      this.estado.value = "";
    } else {
      this.estado.value = contact.estado;
    }
    if (contact.cidade === null) {
      this.cidade.value = "";
    } else {
      this.cidade.value = contact.cidade;
    }
    if (contact.endereco === null) {
      this.endereco.value = "";
    } else {
      this.endereco.value = contact.address;
    }
    if (contact.nascimento === null) {
      this.nascimento.value = "";
    } else {
      var nascimento = Moment(contact.birthday).format("YYYY-MM-DD");
      this.nascimento.value = nascimento;
    }
    if (contact.numberaddress === null) {
      this.numberaddress.value = "";
    } else {
      this.numberaddress.value = contact.numberaddress;
    }
    if (contact.rg === null) {
      this.rg.value = "";
    } else {
      this.rg.value = contact.rg;
    }
    if (contact.cpf === null) {
      this.cpf.value = "";
    } else {
      this.cpf.value = contact.cpf;
    }
  }

  ButtonEdit(action, value) {
    this.setState({ disabled: action });
    if (value === "edit") {
      this.setState({ module: "edit" });
    }
  }

  clearValues(iduser, displayname) {
    this.name.value = "";
    var value = [{ value: iduser, label: displayname }];
    this.setState({ contatode: value });
    this.setState({ empresaC: "" });
    this.setState({ auxEmpresa: "" });
    this.setState({ contactid: "" });
    this.setState({ private: iduser });
    this.setState({ disabled: false });
    this.setState({ person: "" });
    this.setState({ numberC: "" });
    this.setState({ module: "new" });
    this.email.value = "";
    this.displayname.value = "";
    this.cepassociationid.value = "";
    this.codigoexterno.value = "";
    this.cep.value = "";
    this.estado.value = "";
    this.cidade.value = "";
    this.endereco.value = "";
    this.nascimento.value = "";
    this.numberaddress.value = "";
    this.rg.value = "";
    this.cpf.value = "";
  }

  ExitModal(e) {
    MicroModal.close("modal__agenda-pf-usuario-detalhes-history");
    this.clearValues();
  }

  concatNumberDel(e, idnumber) {
    this.setState({ numberDel: this.state.numberDel.concat([idnumber]) });
    this.props.deleteNumber(idnumber);
  }

  updateContact(e, contactid, numberscontact, iduser) {
    var oDivAlerta1 = document.getElementById("msg_erro7");
    var oDivAlerta2 = document.getElementById("msg_erro8");
    var oDivAlerta3 = document.getElementById("msg_erro9");
    var erro = 0;
    var displayname = this.displayname.value;
    var name = this.name.value;
    var email = this.email.value;
    var contatode = this.state.contatode;
    var codigoexterno = this.codigoexterno.value;
    var particular = this.state.private;
    var nascimento = this.nascimento.value;
    var rg = this.rg.value;
    var cpf = this.cpf.value;
    var numero = this.numberaddress.value;
    var endereco = this.endereco.value;
    var cepassociationid = this.cepassociationid.value;
    var district = "";
    var numberdel = this.state.numberDel;

    if (endereco != "") {
      var address = endereco.split(",");
      endereco = address[0];
      district = address[1];
    }

    if (name === "") {
      erro = 1;
      oDivAlerta1.style.display = "block";
      oDivAlerta1.innerHTML = "Preenchimento obrigatório";
    }
    if (contatode === "") {
      erro = 1;
      oDivAlerta3.style.display = "block";
      oDivAlerta3.innerHTML = "Preenchimento obrigatório";
    }
    if (displayname === "") {
      erro = 1;
      oDivAlerta2.style.display = "block";
      oDivAlerta2.innerHTML = "Preenchimento obrigatório";
    }

    if (erro === 0) {
      this.props.UpdateContact(
        contactid,
        displayname,
        name,
        email,
        cpf,
        rg,
        codigoexterno,
        nascimento,
        endereco,
        numero,
        district,
        cepassociationid,
        numberdel,
        particular,
      );
      this.VerifyCompany();
      this.ButtonEdit(true);
      this.VerifiedNumbers(numberscontact, iduser, contactid);
      this.props.GetContactsUnit(contactid);
    }
  }

  VerifiedNumbers(numberscontact, iduser, contactid) {
    this.props.UpdateContactNumber(numberscontact, iduser, contactid);
  }

  VerifyCompany() {
    if (this.state.empresaC) {
      if (this.state.empresaC.length != 0) {
        var companyid = this.state.empresaC;
        companyid = companyid[0].value;

        if (companyid === this.state.auxEmpresa) {
        } else if (
          companyid != this.state.auxEmpresa &&
          this.state.auxEmpresa != "" &&
          this.state.companyid != ""
        ) {
          this.props.UpdateCompanyContact(
            this.state.contactid,
            this.state.auxEmpresa,
          );
          this.props.InsertCompanyContact(this.state.contactid, companyid);
        } else if (
          companyid != this.state.auxEmpresa &&
          companyid != "" &&
          this.state.auxEmpresa === ""
        ) {
          this.props.InsertCompanyContact(this.state.contactid, companyid);
        }
      } else {
        var companyid = this.state.empresaC;
        if (
          companyid != this.state.auxEmpresa &&
          this.state.auxEmpresa != "" &&
          companyid === ""
        ) {
          this.props.UpdateCompanyContact(
            this.state.contactid,
            this.state.auxEmpresa,
          );
        }
      }
    }
  }

  ChangeButtonDateFim(event) {
    this.setState({ buttonShowDateFim: !this.state.buttonShowDateFim });
    localStorage.setItem(
      "button_historic_dateend",
      !this.state.buttonShowDateFim,
    );
  }

  ChangeButtonDateInit(event) {
    this.setState({ buttonShowDateInit: !this.state.buttonShowDateInit });
    localStorage.setItem(
      "button_historic_dateinit",
      !this.state.buttonShowDateInit,
    );
  }

  ChangeButtonChamador(event) {
    this.setState({ buttonShowChamador: !this.state.buttonShowChamador });
    localStorage.setItem(
      "button_historic_chamador",
      !this.state.buttonShowChamador,
    );
  }

  ChangeButtonChamado(event) {
    this.setState({ buttonShowChamado: !this.state.buttonShowChamado });
    localStorage.setItem(
      "button_historic_chamado",
      !this.state.buttonShowChamado,
    );
  }

  ChangeButtonNoAnswer(event) {
    this.setState({ buttonShowNoAnswer: !this.state.buttonShowNoAnswer });
    localStorage.setItem(
      "button_historic_noanswer",
      !this.state.buttonShowNoAnswer,
    );
  }

  ChangeButtonAnswer(event) {
    this.setState({ ButtonShowAnswer: !this.state.ButtonShowAnswer });
    localStorage.setItem(
      "button_historic_answer",
      !this.state.ButtonShowAnswer,
    );
  }

  ChangeButtonEntry(event) {
    this.setState({ ButtonShowEntry: !this.state.ButtonShowEntry });
    localStorage.setItem("button_historic_entry", !this.state.ButtonShowEntry);
  }

  ChangeButtonExit(event) {
    this.setState({ ButtonShowExit: !this.state.ButtonShowExit });
    localStorage.setItem("button_historic_exit", !this.state.ButtonShowExit);
  }

  ChangeButtonFinalizadas(event) {
    this.setState({
      ButtonShowFinalizadas: !this.state.ButtButtonShowFinalizadasonShowExit,
    });
    localStorage.setItem(
      "button_historic_finalizadas",
      !this.state.ButtonShowFinalizadas,
    );
  }

  ChangeButtonClientDesconnection(event) {
    this.setState({
      ButtonShowClientDesconnection: !this.state.ButtonShowClientDesconnection,
    });
    localStorage.setItem(
      "button_historic_client_desconnection",
      !this.state.ButtonShowClientDesconnection,
    );
  }

  ChangeButtonRing(event) {
    this.setState({ buttonShowRing: !this.state.buttonShowRing });
    localStorage.setItem("button_historic_ring", !this.state.buttonShowRing);
  }

  ChangeButtonText(event) {
    this.setState({ ButtonShowText: !this.state.ButtonShowText });
    localStorage.setItem("button_historic_text", !this.state.ButtonShowText);
  }

  ChangeButtonMidia(event) {
    this.setState({ ButtonShowMidia: !this.state.ButtonShowMidia });
    localStorage.setItem("button_historic_midia", !this.state.ButtonShowMidia);
  }

  render() {
    const {
      VerificarUser,
      InfoUsers,
      HistoryUser,
      PermissionRouter,
      OutBandService,
      StatusAgent,
      Companys,
      listCallQueue,
      IPCurrent,
      History,
      TypeNumbers,
      UsersAgents,
      NumbersContact,
      returnCep,
      infoContact,
      PhoneMidia,
    } = this.props;

    const { searchText } = this.state;
    const searchWords = searchText.split(/\s/).filter((word) => word);
    var dia = "";
    var auxdia = "";
    var mes = "";
    var ano = "";

    if (VerificarUser.length === 0) return <Redirect to="/login" />;

    if (HistoryUser.length != 0) {
      this.state.historyUser = HistoryUser.historycalls;
      this.state.totalRegistros = this.state.historyUser.length;
    } else {
      this.state.historyUser = [];
      this.state.totalRegistros = 0;
    }

    this.state.iduser = InfoUsers.id;

    if (History.length) {
      this.state.history = History;
      let testarultimo = 0;
      //this.state.totalhistory = this.state.history[0].interacoes;
      var total = this.state.history[0];
      this.state.totalhistory = total.interacoes;
    } else {
      this.state.history = [];
    }

    if (this.state.RegisterFix.length != 0) {
      var arrayfix = this.state.RegisterFix;
      var cliente =
        arrayfix[0].contactname === ""
          ? arrayfix[0].chamador
          : arrayfix[0].contactname;
      var cdrid = arrayfix[0].cdrid;
      this.state.cliente = cliente;
      this.state.cdrid = cdrid;
    }

    if (TypeNumbers.length != 0) {
      typenumbers = TypeNumbers.typenumbers;
    }

    if (UsersAgents.length != 0) {
      options = UsersAgents;
    }

    if (this.state.buttonshowpfpj === true) {
      var TELAPJPF = "Empresas";
    } else {
      var TELAPJPF = "Contatos";
    }

    if (NumbersContact.length != 0) {
      this.state.numberscontact = NumbersContact;
      NumbersContact.map((nb) => {
        if (nb.exist === true) {
          this.state.disabled = false;
        }
      });
    } else {
      this.state.numberscontact = [];
    }

    if (Companys.length != 0) {
      companys = Companys;
      this.state.companys = Companys;
    } else {
      companys = [];
      this.state.companys = [];
    }

    if (returnCep.length != 0) {
      this.fillCep(returnCep.cep);
    }

    if (PhoneMidia.length != 0) {
      this.state.pathfile = PhoneMidia;
    } else {
      this.state.pathfile = null;
    }

    this.datainit = Moment().format("YYYY-MM-DD");
    this.datafim = Moment().format("YYYY-MM-DD");
    this.timedefaultinit = Moment().format("YYYY-MM-DDT00:00");
    this.timedefaultfim = Moment().format("YYYY-MM-DDT23:59");

    return (
      <div id="historico-atendimentos">
        <div className="stage">
          <div className="canvas">
            <div className="column-historico column-historico--no-padding  column-historico--no-margin-right w-20">
              <div className="block-header">
                <div className="block-header__title">
                  Parâmetros de pesquisa
                </div>
              </div>

              <div className="block">
                <div className=" block-main block-main--small-column">
                  <div className="checkbox checkbox__list">
                    <ul>
                      <li className="active">
                        {/* <input
                          type="checkbox"
                          className="checkbox__list__input"
                          id="checkbox-data-inicio"
                          name="checkbox-data-inicio"
                          defaultChecked={this.state.buttonShowDateInit}
                          onChange={(event) => this.ChangeButtonDateInit(event)}
                        /> */}
                        <label htmlFor="checkbox-data-inicio">
                          Data início
                        </label>

                        <input
                          style={{
                            display: this.state.buttonShowDateInit
                              ? "block"
                              : "none",
                          }}
                          className="input-text"
                          type="date"
                          ref={(input) => (this.dataInit = input)}
                          defaultValue={this.datainit}
                        />
                      </li>

                      <li className="active">
                        {/* <input
                          type="checkbox"
                          className="checkbox__list__input"
                          id="checkbox-data-fim"
                          name="checkbox-data-fim"
                          defaultChecked={this.state.buttonShowDateFim}
                          onChange={(event) => this.ChangeButtonDateFim(event)}
                        /> */}
                        <label htmlFor="checkbox-data-fim">Data fim</label>

                        <input
                          style={{
                            display: this.state.buttonShowDateFim
                              ? "block"
                              : "none",
                          }}
                          className="input-text"
                          type="date"
                          ref={(input) => (this.dataFim = input)}
                          defaultValue={this.datafim}
                        />
                      </li>

                      <li className="active">
                        <input
                          type="checkbox"
                          className="checkbox__list__input"
                          id="checkbox-chamador"
                          name="checkbox-chamador"
                          defaultChecked={this.state.buttonShowChamador}
                          onChange={(event) => this.ChangeButtonChamador(event)}
                        />
                        <label htmlFor="checkbox-chamador">Chamador</label>

                        <input
                          style={{
                            display: this.state.buttonShowChamador
                              ? "block"
                              : "none",
                          }}
                          className="input-text"
                          ref={(input) => (this.chamador = input)}
                          type="text"
                        />
                      </li>

                      <li className="active">
                        <input
                          type="checkbox"
                          className="checkbox__list__input"
                          id="checkbox-chamado"
                          name="checkbox-chamado"
                          defaultChecked={this.state.buttonShowChamado}
                          onChange={(event) => this.ChangeButtonChamado(event)}
                        />
                        <label htmlFor="checkbox-chamado">Chamado</label>

                        <input
                          style={{
                            display: this.state.buttonShowChamado
                              ? "block"
                              : "none",
                          }}
                          className="input-text"
                          type="text"
                          ref={(input) => (this.chamado = input)}
                        />
                      </li>

                      <li className="active">
                        <input
                          className="checkbox__list__input"
                          ref={(input) => (this.naoatendidas = input)}
                          id="checkbox-nao-atendidas"
                          defaultChecked={this.state.buttonShowNoAnswer}
                          onChange={(event) => this.ChangeButtonNoAnswer(event)}
                          type="checkbox"
                        />
                        <label htmlFor="checkbox-nao-atendidas">
                          Não atendidas
                        </label>
                      </li>

                      <li className="active">
                        <input
                          className="checkbox__list__input"
                          ref={(input) => (this.atendidas = input)}
                          id="checkbox-atendidas"
                          defaultChecked={this.state.ButtonShowAnswer}
                          onChange={(event) => this.ChangeButtonAnswer(event)}
                          type="checkbox"
                        />
                        <label htmlFor="checkbox-atendidas">Atendidas</label>
                      </li>
                      <li className="active">
                        <input
                          className="checkbox__list__input"
                          ref={(input) => (this.finalizadas = input)}
                          defaultChecked={this.state.ButtonShowFinalizadas}
                          onChange={(event) =>
                            this.ChangeButtonFinalizadas(event)
                          }
                          id="checkbox-finalizadas"
                          type="checkbox"
                        />
                        <label htmlFor="checkbox-finalizadas">
                          Finalizadas
                        </label>
                      </li>

                      <li className="active">
                        <input
                          className="checkbox__list__input"
                          ref={(input) => (this.entrada = input)}
                          defaultChecked={this.state.ButtonShowEntry}
                          onChange={(event) => this.ChangeButtonEntry(event)}
                          id="checkbox-entrada"
                          type="checkbox"
                        />
                        <label htmlFor="checkbox-entrada">Entrada</label>
                      </li>

                      <li className="active">
                        <input
                          className="checkbox__list__input"
                          ref={(input) => (this.saida = input)}
                          defaultChecked={this.state.ButtonShowExit}
                          onChange={(event) => this.ChangeButtonExit(event)}
                          id="checkbox-saida"
                          type="checkbox"
                        />
                        <label htmlFor="checkbox-saida">Saída</label>
                      </li>

                      <li className="active" style={{ display: "none" }}>
                        <input
                          className="checkbox__list__input"
                          ref={(input) => (this.livre = input)}
                          id="checkbox-livre"
                          type="checkbox"
                        />
                        <label htmlFor="checkbox-livre">Livre</label>
                      </li>

                      <li className="active" style={{ display: "none" }}>
                        <input
                          className="checkbox__list__input"
                          ref={(input) => (this.ocupado = input)}
                          id="checkbox-ocupado"
                          type="checkbox"
                        />
                        <label htmlFor="checkbox-ocupado">Ocupado</label>
                      </li>

                      {/* <li className="hide">
                                <input className="checkbox__list__input" ref={input => this.desconexao = input} defaultChecked={this.state.ButtonShowClientDesconnection} onChange={event => this.ChangeButtonClientDesconnection(event)} id="checkbox-desconexao" type="checkbox" />
                                <label htmlFor="checkbox-desconexao">Cliente desconectou</label> 
                                </li> */}

                      <li className="active">
                        <input
                          className="checkbox__list__input"
                          id="checkbox-min-ring"
                          name="checkbox-min-ring"
                          defaultChecked={this.state.buttonShowRing}
                          onChange={(event) => this.ChangeButtonRing(event)}
                          type="checkbox"
                        />
                        <label htmlFor="checkbox-min-ring">Min.Ring</label>

                        <input
                          style={{
                            display: this.state.buttonShowRing
                              ? "block"
                              : "none",
                          }}
                          className="input-text"
                          type="text"
                          ref={(input) => (this.ring = input)}
                        />
                      </li>

                      <li className="active">
                        <input
                          className="checkbox__list__input"
                          id="checkbox-frase"
                          name="checkbox-frase"
                          defaultChecked={this.state.ButtonShowText}
                          onChange={(event) => this.ChangeButtonText(event)}
                          type="checkbox"
                        />
                        <label htmlFor="checkbox-frase">Palavra/Frase</label>

                        <input
                          style={{
                            display: this.state.ButtonShowText
                              ? "block"
                              : "none",
                          }}
                          className="input-text"
                          type="text"
                          placeholder="Digite..."
                          onChange={(e) =>
                            this.setState({ mensagem: e.target.value })
                          }
                        />
                      </li>

                      <li className="active">
                        <input
                          className="checkbox__list__input"
                          id="checkbox-midia"
                          type="checkbox"
                          defaultChecked={this.state.ButtonShowMidia}
                          onChange={(event) => this.ChangeButtonMidia(event)}
                        />
                        <label htmlFor="checkbox-midia">Canais</label>
                        <div
                          className={
                            this.state.ButtonShowMidia
                              ? "select select--parametros active"
                              : "select select--parametros"
                          }
                        >
                          <div className="options options--parametros">
                            <div className="checkbox">
                              <div
                                className="checkbox__row inline"
                                style={{ paddingRight: 5 }}
                              >
                                <div className="checkbox__row__input-icon-box">
                                  <input
                                    type="checkbox"
                                    name="midia-check"
                                    id="whatsapp-geral"
                                    defaultChecked={
                                      this.state.MidiasId.findIndex(
                                        function (val) {
                                          return val === 5;
                                        },
                                      ) !== -1
                                        ? true
                                        : false
                                    }
                                    onChange={(event) =>
                                      this.filterMidia(event, 5)
                                    }
                                  />
                                  <label
                                    className="checkbox__row__input-icon-box__label"
                                    htmlFor="whatsapp-geral"
                                  >
                                    <img
                                      width="25"
                                      height="25"
                                      src={MIDIAZAP}
                                      alt=""
                                      className="tippy-default"
                                      data-tippy-content="Whatsapp"
                                    />
                                  </label>
                                </div>
                                <div className="checkbox__row__input-icon-box">
                                  <input
                                    type="checkbox"
                                    name="midia-check"
                                    id="voz-geral"
                                    defaultChecked={
                                      this.state.MidiasId.findIndex(
                                        function (val) {
                                          return val === 1;
                                        },
                                      ) !== -1
                                        ? true
                                        : false
                                    }
                                    onChange={(event) =>
                                      this.filterMidia(event, 1)
                                    }
                                  />
                                  <label
                                    className="checkbox__row__input-icon-box__label"
                                    htmlFor="voz-geral"
                                  >
                                    <img
                                      width="25"
                                      height="25"
                                      src={CALLCHAT}
                                      alt=""
                                      className="tippy-default"
                                      data-tippy-content="Voz"
                                    />
                                  </label>
                                </div>
                                <div className="checkbox__row__input-icon-box">
                                  <input
                                    type="checkbox"
                                    name="midia-check"
                                    id="webchat-geral"
                                    defaultChecked={
                                      this.state.MidiasId.findIndex(
                                        function (val) {
                                          return val === 2;
                                        },
                                      ) !== -1
                                        ? true
                                        : false
                                    }
                                    onChange={(event) =>
                                      this.filterMidia(event, 2)
                                    }
                                  />
                                  <label
                                    className="checkbox__row__input-icon-box__label"
                                    htmlFor="webchat-geral"
                                  >
                                    <img
                                      width="25"
                                      height="25"
                                      src={MIDIAWEB}
                                      alt=""
                                      className="tippy-default"
                                      data-tippy-content="Webchat"
                                    />
                                  </label>
                                </div>
                                <div className="checkbox__row__input-icon-box">
                                  <input
                                    type="checkbox"
                                    name="midia-check"
                                    id="facebook-geral"
                                    defaultChecked={
                                      this.state.MidiasId.findIndex(
                                        function (val) {
                                          return val === 4;
                                        },
                                      ) !== -1
                                        ? true
                                        : false
                                    }
                                    onChange={(event) =>
                                      this.filterMidia(event, 4)
                                    }
                                  />
                                  <label
                                    className="checkbox__row__input-icon-box__label"
                                    htmlFor="facebook-geral"
                                  >
                                    <img
                                      width="25"
                                      height="25"
                                      src={MIDIAFACELARGE}
                                      alt=""
                                      className="tippy-default"
                                      data-tippy-content="facebook"
                                    />
                                  </label>
                                </div>
                                <div className="checkbox__row__input-icon-box">
                                  <input
                                    type="checkbox"
                                    name="midia-check"
                                    id="email-geral"
                                    defaultChecked={
                                      this.state.MidiasId.findIndex(
                                        function (val) {
                                          return val === 3;
                                        },
                                      ) !== -1
                                        ? true
                                        : false
                                    }
                                    onChange={(event) =>
                                      this.filterMidia(event, 3)
                                    }
                                  />
                                  <label
                                    className="checkbox__row__input-icon-box__label"
                                    htmlFor="email-geral"
                                  >
                                    <img
                                      width="25"
                                      height="25"
                                      src={MIDIAEMAIL}
                                      alt=""
                                      className="tippy-default"
                                      data-tippy-content="email"
                                    />
                                  </label>
                                </div>
                                <div className="checkbox__row__input-icon-box">
                                  <input
                                    type="checkbox"
                                    name="midia-check"
                                    id="telegram-geral"
                                    defaultChecked={
                                      this.state.MidiasId.findIndex(
                                        function (val) {
                                          return val === 8;
                                        },
                                      ) !== -1
                                        ? true
                                        : false
                                    }
                                    onChange={(event) =>
                                      this.filterMidia(event, 8)
                                    }
                                  />
                                  <label
                                    className="checkbox__row__input-icon-box__label"
                                    htmlFor="telegram-geral"
                                  >
                                    <img
                                      width="25"
                                      height="25"
                                      src={MIDIATELEGRAM}
                                      alt=""
                                      className="tippy-default"
                                      data-tippy-content="telegram"
                                    />
                                  </label>
                                </div>
                                <div className="checkbox__row__input-icon-box">
                                  <input
                                    type="checkbox"
                                    name="midia-check"
                                    id="googlegbm-geral"
                                    defaultChecked={
                                      this.state.MidiasId.findIndex(
                                        function (val) {
                                          return val === 11;
                                        },
                                      ) !== -1
                                        ? true
                                        : false
                                    }
                                    onChange={(event) =>
                                      this.filterMidia(event, 11)
                                    }
                                  />
                                  <label
                                    className="checkbox__row__input-icon-box__label"
                                    htmlFor="googlegbm-geral"
                                  >
                                    <img
                                      width="25"
                                      height="25"
                                      src={GOOGLEGBMLARGE}
                                      alt=""
                                      className="tippy-default"
                                      data-tippy-content="googlegbm"
                                    />
                                  </label>
                                </div>
                                <div className="checkbox__row__input-icon-box">
                                  <input
                                    type="checkbox"
                                    name="midia-check"
                                    id="instagram-geral"
                                    defaultChecked={
                                      this.state.MidiasId.findIndex(
                                        function (val) {
                                          return val === 6;
                                        },
                                      ) !== -1
                                        ? true
                                        : false
                                    }
                                    onChange={(event) =>
                                      this.filterMidia(event, 6)
                                    }
                                  />
                                  <label
                                    className="checkbox__row__input-icon-box__label"
                                    htmlFor="instagram-geral"
                                  >
                                    <img
                                      width="25"
                                      height="25"
                                      src={INSTAGRAMLARGE}
                                      alt=""
                                      className="tippy-default"
                                      data-tippy-content="instagram"
                                    />
                                  </label>
                                </div>
                                <div className="checkbox__row__input-icon-box">
                                  <input
                                    type="checkbox"
                                    name="midia-check"
                                    id="twitter-geral"
                                    defaultChecked={
                                      this.state.MidiasId.findIndex(
                                        function (val) {
                                          return val === 9;
                                        },
                                      ) !== -1
                                        ? true
                                        : false
                                    }
                                    onChange={(event) =>
                                      this.filterMidia(event, 9)
                                    }
                                  />
                                  <label
                                    className="checkbox__row__input-icon-box__label"
                                    htmlFor="twitter-geral"
                                  >
                                    <img
                                      width="25"
                                      height="25"
                                      src={TWITTER}
                                      alt=""
                                      className="tippy-default"
                                      data-tippy-content="twitter"
                                    />
                                  </label>
                                </div>
                                <div className="checkbox__row__input-icon-box">
                                  <input
                                    type="checkbox"
                                    name="midia-check"
                                    id="linkedin-geral"
                                    defaultChecked={
                                      this.state.MidiasId.findIndex(
                                        function (val) {
                                          return val === 10;
                                        },
                                      ) !== -1
                                        ? true
                                        : false
                                    }
                                    onChange={(event) =>
                                      this.filterMidia(event, 10)
                                    }
                                  />
                                  <label
                                    className="checkbox__row__input-icon-box__label"
                                    htmlFor="linkedin-geral"
                                  >
                                    <img
                                      width="25"
                                      height="25"
                                      src={LINKEDIN}
                                      alt=""
                                      className="tippy-default"
                                      data-tippy-content="linkedin"
                                    />
                                  </label>
                                </div>
                                <div className="checkbox__row__input-icon-box">
                                  <input
                                    type="checkbox"
                                    name="midia-check"
                                    id="sms-geral"
                                    defaultChecked={
                                      this.state.MidiasId.findIndex(
                                        function (val) {
                                          return val === 5;
                                        },
                                      ) !== -1
                                        ? true
                                        : false
                                    }
                                    onChange={(event) =>
                                      this.filterMidia(event, 12)
                                    }
                                  />
                                  <label
                                    className="checkbox__row__input-icon-box__label"
                                    htmlFor="sms-geral"
                                  >
                                    <SMSICON />
                                  </label>
                                </div>
                                <div className="checkbox__row__input-icon-box">
                                  <input
                                    type="checkbox"
                                    name="midia-check"
                                    id="teams-geral"
                                    defaultChecked={
                                      this.state.MidiasId.findIndex(
                                        function (val) {
                                          return val === 15;
                                        },
                                      ) !== -1
                                        ? true
                                        : false
                                    }
                                    onChange={(event) =>
                                      this.filterMidia(event, 15)
                                    }
                                  />
                                  <label
                                    className="checkbox__row__input-icon-box__label"
                                    htmlFor="teams-geral"
                                  >
                                    <img
                                      width="25"
                                      height="25"
                                      src={TEAMS}
                                      alt=""
                                      className="tippy-default"
                                      data-tippy-content="teams"
                                    />
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className={
                  this.state.disablebutton
                    ? "block-footer no-border disabled"
                    : "block-footer no-border"
                }
              >
                {/* <div className="block-footer no-border"> */}
                <button
                  type="button"
                  id="button_pesquisar"
                  className="btn-tercenary center"
                  onClick={(event) => this.buttonSearchUserHistory(event)}
                >
                  Pesquisar
                </button>
              </div>
            </div>
            <div className="column-historico column-historico--no-padding w-80">
              <div className="block-header">
                <div className="block-header__title">
                  Histórico de atendimentos
                </div>
              </div>

              <div className="block">
                {/* <!-- Descrição --> */}
                <div className="block-main">
                  <div className="block-main__content__tab-header light active no-padding-top">
                    <div
                      className={
                        this.state.sortName === "mediaid"
                          ? "block-main__content__tab-header__col block-main__content__tab-header__col--1 " +
                            this.state.ordemSort
                          : "block-main__content__tab-header__col block-main__content__tab-header__col--1"
                      }
                      onClick={(event) =>
                        this.sortByName(event, "mediaid", this.state.ordemSort)
                      }
                    >
                      Canal
                    </div>
                    <div
                      className={
                        this.state.sortName === "to_char"
                          ? "block-main__content__tab-header__col block-main__content__tab-header__col--3 " +
                            this.state.ordemSort
                          : "block-main__content__tab-header__col block-main__content__tab-header__col--3"
                      }
                      onClick={(event) =>
                        this.sortByName(event, "to_char", this.state.ordemSort)
                      }
                    >
                      Data/Hora Inicio
                    </div>
                    <div
                      className={
                        this.state.sortName === "dateend"
                          ? "block-main__content__tab-header__col block-main__content__tab-header__col--3 " +
                            this.state.ordemSort
                          : "block-main__content__tab-header__col block-main__content__tab-header__col--3"
                      }
                      onClick={(event) =>
                        this.sortByName(event, "dateend", this.state.ordemSort)
                      }
                    >
                      Data/Hora Fim
                    </div>
                    <div
                      className={
                        this.state.sortName === "ring"
                          ? "block-main__content__tab-header__col block-main__content__tab-header__col--2 " +
                            this.state.ordemSort
                          : "block-main__content__tab-header__col block-main__content__tab-header__col--2"
                      }
                      onClick={(event) =>
                        this.sortByName(event, "ring", this.state.ordemSort)
                      }
                    >
                      Dur.Ring.
                    </div>
                    <div
                      className={
                        this.state.sortName === "duration"
                          ? "block-main__content__tab-header__col block-main__content__tab-header__col--2 " +
                            this.state.ordemSort
                          : "block-main__content__tab-header__col block-main__content__tab-header__col--2"
                      }
                      onClick={(event) =>
                        this.sortByName(event, "duration", this.state.ordemSort)
                      }
                    >
                      Duração
                    </div>
                    <div
                      className={
                        this.state.sortName === "contactname"
                          ? "block-main__content__tab-header__col block-main__content__tab-header__col--3 " +
                            this.state.ordemSort
                          : "block-main__content__tab-header__col block-main__content__tab-header__col--3"
                      }
                      onClick={(event) =>
                        this.sortByName(
                          event,
                          "contactname",
                          this.state.ordemSort,
                        )
                      }
                    >
                      Nome
                    </div>
                    <div
                      className={
                        this.state.sortName === "called"
                          ? "block-main__content__tab-header__col block-main__content__tab-header__col--3 " +
                            this.state.ordemSort
                          : "block-main__content__tab-header__col block-main__content__tab-header__col--3"
                      }
                      onClick={(event) =>
                        this.sortByName(event, "called", this.state.ordemSort)
                      }
                    >
                      Chamado
                    </div>
                    <div
                      className={
                        this.state.sortName === "caller"
                          ? "block-main__content__tab-header__col block-main__content__tab-header__col--3 " +
                            this.state.ordemSort
                          : "block-main__content__tab-header__col block-main__content__tab-header__col--3"
                      }
                      onClick={(event) =>
                        this.sortByName(event, "caller", this.state.ordemSort)
                      }
                    >
                      Chamador
                    </div>
                    <div
                      className={
                        this.state.sortName === "directionin"
                          ? "block-main__content__tab-header__col block-main__content__tab-header__col--2 " +
                            this.state.ordemSort
                          : "block-main__content__tab-header__col block-main__content__tab-header__col--2"
                      }
                      onClick={(event) =>
                        this.sortByName(
                          event,
                          "directionin",
                          this.state.ordemSort,
                        )
                      }
                    >
                      Tipo
                    </div>
                    <div
                      className={
                        this.state.sortName === "answer"
                          ? "block-main__content__tab-header__col block-main__content__tab-header__col--2 " +
                            this.state.ordemSort
                          : "block-main__content__tab-header__col block-main__content__tab-header__col--2"
                      }
                      onClick={(event) =>
                        this.sortByName(event, "answer", this.state.ordemSort)
                      }
                    >
                      Situação
                    </div>
                    <div
                      className={
                        this.state.sortName === "razao_desc"
                          ? "block-main__content__tab-header__col block-main__content__tab-header__col--2 " +
                            this.state.ordemSort
                          : "block-main__content__tab-header__col block-main__content__tab-header__col--2"
                      }
                      onClick={(event) =>
                        this.sortByName(
                          event,
                          "razao_desc",
                          this.state.ordemSort,
                        )
                      }
                    >
                      Razão de desconexão
                    </div>
                    <div
                      className={
                        this.state.sortName === "displayname"
                          ? "block-main__content__tab-header__col block-main__content__tab-header__col--2 " +
                            this.state.ordemSort
                          : "block-main__content__tab-header__col block-main__content__tab-header__col--2"
                      }
                      onClick={(event) =>
                        this.sortByName(
                          event,
                          "displayname",
                          this.state.ordemSort,
                        )
                      }
                    >
                      Agente
                    </div>
                    <div
                      className={
                        this.state.sortName === "protocolo"
                          ? "block-main__content__tab-header__col block-main__content__tab-header__col--2 " +
                            this.state.ordemSort
                          : "block-main__content__tab-header__col block-main__content__tab-header__col--2"
                      }
                      onClick={(event) =>
                        this.sortByName(
                          event,
                          "protocolo",
                          this.state.ordemSort,
                        )
                      }
                    >
                      Protocolo
                    </div>
                    <div
                      className={
                        this.state.sortName === "status"
                          ? "block-main__content__tab-header__col block-main__content__tab-header__col--2 " +
                            this.state.ordemSort
                          : "block-main__content__tab-header__col block-main__content__tab-header__col--2"
                      }
                      onClick={(event) =>
                        this.sortByName(event, "status", this.state.ordemSort)
                      }
                    >
                      Estado
                    </div>
                  </div>
                  {/* <!-- fim descrição --> */}

                  {this.state.historyUser.map((history, index) => (
                    <div
                      key={index}
                      onClick={(event) =>
                        this.checkFixRegister(
                          event,
                          history.cdrid,
                          history.caller,
                          history.cdrid,
                          history.called,
                          history.iddirection,
                          history.idmidia,
                          history.to_char,
                          history.contactname,
                          history.contactid,
                          history.idtrunk,
                        )
                      }
                      className={
                        this.state.expandRegister === history.cdrid
                          ? "block-main__content__tab-body padding-top active"
                          : "block-main__content__tab-body padding-top"
                      }
                    >
                      <div className="block-main__content__tab-body__col block-main__content__tab-body__col--1">
                        {(() => {
                          if (history.mediaid === 5) {
                            history.mediaid = "Whatsapp";
                          } else if (history.mediaid === 1) {
                            history.mediaid = "Voz";
                          } else if (history.mediaid === 4) {
                            history.mediaid = "Facebook";
                          } else if (history.mediaid === 2) {
                            history.mediaid = "Webchat";
                          } else if (history.mediaid === 3) {
                            history.mediaid = "email";
                          } else if (history.mediaid === 6) {
                            history.mediaid = "instagram";
                          } else if (history.mediaid === 8) {
                            history.mediaid = "telegram";
                          } else if (history.mediaid === 9) {
                            history.mediaid = "twitter";
                          } else if (history.mediaid === 10) {
                            history.mediaid = "linkedin";
                          } else if (history.mediaid === 11) {
                            history.mediaid = "googlegbm";
                          } else if (history.mediaid === 12) {
                            history.mediaid = "sms";
                          } else if (history.mediaid === 15) {
                            history.mediaid = "teams";
                          }

                          if (history.mediaid === "Voz") {
                            return (
                              <img
                                className="block-main__icons"
                                src={CALLCHAT}
                                alt=""
                              />
                            );
                          } else if (history.mediaid === "Facebook") {
                            return (
                              <img
                                className="block-main__icons"
                                src={MIDIAFACE}
                                alt=""
                              />
                            );
                          } else if (history.mediaid === "Whatsapp") {
                            return (
                              <img
                                className="block-main__icons"
                                src={MIDIAZAP}
                                alt=""
                              />
                            );
                          } else if (history.mediaid === "Webchat") {
                            return (
                              <img
                                className="block-main__icons"
                                src={MIDIAWEB}
                                alt=""
                              />
                            );
                          } else if (history.mediaid === "email") {
                            return (
                              <img
                                className="block-main__icons"
                                src={MIDIAEMAIL}
                                alt=""
                              />
                            );
                          } else if (history.mediaid === "instagram") {
                            return (
                              <img
                                className="block-main__icons"
                                src={INSTAGRAM}
                                alt=""
                              />
                            );
                          } else if (history.mediaid === "telegram") {
                            return (
                              <img
                                className="block-main__icons"
                                src={MIDIATELEGRAM}
                                alt=""
                              />
                            );
                          } else if (history.mediaid === "twitter") {
                            return (
                              <img
                                className="block-main__icons"
                                src={TWITTER}
                                alt=""
                              />
                            );
                          } else if (history.mediaid === "linkedin") {
                            return (
                              <img
                                className="block-main__icons"
                                src={LINKEDIN}
                                alt=""
                              />
                            );
                          } else if (history.mediaid === "sms") {
                            return <SMSICON />;
                          } else if (history.mediaid === "googlegbm") {
                            return (
                              <img
                                className="block-main__icons"
                                src={GOOGLEGBM}
                                alt=""
                              />
                            );
                          } else if (history.mediaid === "teams") {
                            return (
                              <img
                                className="block-main__icons"
                                src={TEAMS}
                                alt=""
                              />
                            );
                          }
                        })()}
                      </div>
                      <div
                        className="block-main__content__tab-body__col block-main__content__tab-body__col--3"
                        title={history.to_char}
                      >
                        {history.to_char}
                      </div>
                      <div
                        className="block-main__content__tab-body__col block-main__content__tab-body__col--3"
                        title={history.dateend}
                      >
                        {history.dateend}
                      </div>
                      {(() => {
                        var hours = Math.floor(history.duracaoring / 3600);
                        if (hours <= 9) hours = "0" + hours;
                        var minutes = Math.floor(
                          (history.duracaoring % 3600) / 60,
                        );
                        if (minutes <= 9) minutes = "0" + minutes;
                        var seconds = history.duracaoring % 60;
                        if (seconds <= 9) seconds = "0" + seconds;
                        history.ringduration =
                          hours + ":" + minutes + ":" + seconds;
                        return (
                          <div
                            className="block-main__content__tab-body__col block-main__content__tab-body__col--2"
                            title={hours + ":" + minutes + ":" + seconds}
                          >
                            {hours + ":" + minutes + ":" + seconds}
                          </div>
                        );
                      })()}
                      {(() => {
                        var hours = Math.floor(history.duracao / 3600);
                        if (hours <= 9) hours = "0" + hours;
                        var minutes = Math.floor((history.duracao % 3600) / 60);
                        if (minutes <= 9) minutes = "0" + minutes;
                        var seconds = history.duracao % 60;
                        if (seconds <= 9) seconds = "0" + seconds;
                        history.duration =
                          hours + ":" + minutes + ":" + seconds;
                        return (
                          <div
                            className="block-main__content__tab-body__col block-main__content__tab-body__col--2"
                            title={hours + ":" + minutes + ":" + seconds}
                          >
                            {hours + ":" + minutes + ":" + seconds}
                          </div>
                        );
                      })()}
                      <div
                        className="block-main__content__tab-body__col block-main__content__tab-body__col--3"
                        title={createJSON(history.contactname)}
                      >
                        {createJSON(history.contactname)}
                      </div>
                      <div
                        className="block-main__content__tab-body__col block-main__content__tab-body__col--3"
                        title={history.called}
                      >
                        {history.called}
                      </div>
                      <div
                        className="block-main__content__tab-body__col block-main__content__tab-body__col--3"
                        title={history.caller}
                      >
                        {history.caller}
                      </div>
                      {(() => {
                        if (history.directionin === 1) {
                          history.directionin = "Receptivo";
                        }
                        if (history.directionin === 2) {
                          history.directionin = "Saída";
                        }
                      })()}
                      <div
                        className="block-main__content__tab-body__col block-main__content__tab-body__col--2"
                        title={history.directionin}
                      >
                        {history.directionin}
                      </div>
                      {(() => {
                        if (history.answer === true) {
                          history.answer = "Atendido";
                        } else if (history.answer === false) {
                          history.answer = "Não Atendido";
                        }
                      })()}
                      <div
                        className="block-main__content__tab-body__col block-main__content__tab-body__col--2"
                        title={history.answer}
                      >
                        {history.answer}
                      </div>
                      <div
                        className="block-main__content__tab-body__col block-main__content__tab-body__col--2"
                        title={history.razao_desc}
                      >
                        {history.razao_desc}
                      </div>
                      <div
                        className="block-main__content__tab-body__col block-main__content__tab-body__col--2"
                        title={history.displayname}
                      >
                        {history.displayname}
                      </div>
                      <div
                        className="block-main__content__tab-body__col block-main__content__tab-body__col--2"
                        title={history.protocolo}
                      >
                        {history.protocolo}
                      </div>
                      <div
                        className="block-main__content__tab-body__col block-main__content__tab-body__col--2"
                        title={history.status}
                      >
                        {history.status}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="block-footer">
                <div className="block-footer__row">
                  <i className="material-icons icon-grey">list_alt</i>
                  <div className="block-footer__text">
                    Total de registros retornados: {this.state.totalRegistros}
                  </div>
                </div>
                <div
                  style={{ display: this.state.senhaincorreta, color: "red" }}
                  className="invalid-feedback"
                  id="div_alert"
                ></div>
                <div className="block-footer__row block-footer__row--with-icon">
                  <div className="block-footer__text block-footer__text--light">
                    O que deseja saber?
                  </div>
                  <button
                    href="#"
                    className="btn action with-icon tippy-default active"
                    id="action-shutdown"
                    onClick={(event) => {
                      let filteredPermissionRouter = PermissionRouter;
                      const hasRegisterFix =
                        Boolean(this.state.RegisterFix) &&
                        Array.isArray(this.state.RegisterFix) &&
                        this.state.RegisterFix.length > 0 &&
                        Boolean(this.state.RegisterFix[0]);
                      if (hasRegisterFix) {
                        filteredPermissionRouter = filtrarTroncosParaOHistorico(
                          this.state.RegisterFix[0].idtrunk,
                          PermissionRouter,
                        );
                      }
                      this.SolicitarChamadaAtiva(
                        event,
                        filteredPermissionRouter,
                        OutBandService,
                        InfoUsers,
                        StatusAgent.status,
                        listCallQueue,
                        IPCurrent,
                        StatusAgent,
                      );
                    }}
                    data-tooltip="Ligar"
                  >
                    <i className="material-icons">call_end</i>
                  </button>
                  <button
                    href="#"
                    className="btn action with-icon tippy-default"
                    onClick={(event) =>
                      this.InsertContactOfHistory(event, InfoUsers)
                    }
                    id="action-2"
                    data-tooltip="Adicionar Contato"
                    style={{
                      pointerEvents: "none",
                      background: "#b7bec5",
                      color: "white",
                    }}
                  >
                    <i className="material-icons">person_add</i>
                  </button>
                  {/* <button href="#" className="btn action with-icon tippy-default" id="action-3" disabled data-tooltip="Salvar novo Contato"><i className="material-icons">contacts</i></button> */}
                  <button
                    href="#"
                    className="btn action with-icon tippy-default"
                    id="action-4"
                    onClick={(event) =>
                      this.ChangeInfoContact(event, infoContact)
                    }
                    data-tooltip="Informações do Contato"
                  >
                    <i className="material-icons">description</i>
                  </button>
                  <CSVLink
                    data={this.state.historyUser}
                    headers={headers}
                    filename={"historico.csv"}
                    separator={";"}
                  >
                    <button
                      href="#"
                      className="btn action with-icon tippy-default"
                      id="action-5"
                      data-tooltip="Exportar Dados"
                    >
                      <i className="material-icons">save_alt</i>
                    </button>
                  </CSVLink>
                  <button
                    href="#"
                    className="btn action with-icon tippy-default"
                    id="action-6"
                    data-tooltip="Detalhes do Atendimento"
                    onClick={(event) => this.DisplayModalHistory(event)}
                  >
                    <i className="material-icons">settings_phone</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal micromodal-slide"
            id="modal__agenda-pj-empresa-detalhes-editar-salvo-history"
            aria-hidden="true"
            role="dialog"
          >
            <div className="modal__overlay" tabIndex="-1">
              <div
                className="modal__container"
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal__agenda-pj-empresa-detalhes-editar-salvo__title"
              >
                <header className="modal__header">
                  <h2
                    className="modal__title"
                    id="modal__agenda-pj-empresa-detalhes-editar-salvo__title"
                  >
                    Contatos
                  </h2>
                  <button
                    className="modal__close"
                    aria-label="Close modal"
                    onClick={(event) =>
                      this.ShowModal(event, "modal_contato_salvo")
                    }
                  ></button>
                </header>
                <main
                  className="modal__content"
                  id="modal__agenda-pj-empresa-detalhes-editar-salvo__content"
                >
                  <form action="" className="modal__content__form">
                    <div className="modal__content__form__row">
                      <div className="modal__content__form__group modal__content__form__group--col-8">
                        <div className="modal__content-center">
                          <img src={CONTATOSALVO} alt="" />
                          <div className="modal-box__text-box">
                            <p className="modal-box__text-message">
                              Seu contato foi adicionado
                            </p>
                            <p className="modal-box__text-message modal-box__text-message--bold">
                              com sucesso!
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal__content__form__group modal__content__form__group--col-2"></div>
                    <div className="modal__content__form__group modal__content__form__group--col-2">
                      <a
                        onClick={(event) =>
                          this.FindContact(event, "modal__agenda")
                        }
                        className="modal__content__form__group__button"
                      >
                        Buscar um Contato
                      </a>
                    </div>
                    <div className="modal__content__form__group modal__content__form__group--col-2">
                      <a
                        onClick={(event) => this.CloseModalSalvo(event)}
                        className="modal__content__form__group__button modal__content__form__group__button--white"
                      >
                        Retornar ao histórico
                      </a>
                    </div>
                  </form>
                </main>
              </div>
            </div>
          </div>

          <>
            <div
              className="modal micromodal-slide"
              id="modal__historico-atendimento"
              aria-hidden="true"
              role="dialog"
            >
              <div className="modal__overlay" tabIndex="-1">
                <div
                  className="modal__container"
                  role="dialog"
                  aria-modal="true"
                  aria-labelledby="modal__historico-atendimento__title"
                >
                  <header className="modal__header">
                    <h2
                      className="modal__title"
                      id="modal__historico-atendimento__title"
                    >
                      Interações
                    </h2>
                    <button
                      className="modal__close"
                      aria-label="Close modal"
                      data-micromodal-close
                    ></button>
                  </header>
                  <main
                    className="modal__content"
                    id="modal__historico-atendimento__content"
                  >
                    <div className="hist-atd__info">
                      <div className="hist-atd__info-items">
                        <p className="hist-atd__name  is-poppins">
                          {createJSON(this.state.cliente)}
                        </p>
                        <i className="material-icons hist-atd__icon">
                          question_answer
                        </i>{" "}
                        <span className="hist-atd__info-text">
                          Total de{" "}
                          <span className="hist-atd__counter">
                            {this.state.totalhistory}
                          </span>{" "}
                          interações&#x28;s&#x29;
                        </span>
                      </div>
                      {(() => {
                        if (InfoUsers.permdownload === true) {
                          return (
                            <div className="hist-atd__info-pdf">
                              <a href="#" onClick={this.exportPDFWithMethod}>
                                <img src={ICONPDFEXPORT} />
                                Exportar PDF
                              </a>
                            </div>
                          );
                        }
                      })()}
                    </div>
                    <div className="hist-atd__ctrls">
                      <p className="hist-atd__text">Período:</p>
                      <span className="hist-atd__span">De:</span>
                      <input
                        type="datetime-local"
                        defaultValue={this.timedefaultinit}
                        className="hist-atd__end"
                        id="hist_start"
                      />
                      <span className="hist-atd__span">Até:</span>
                      <input
                        type="datetime-local"
                        defaultValue={this.timedefaultfim}
                        className="hist-atd__end"
                        id="hist_end"
                      />
                      <button
                        className="hist-atd__search-btn"
                        onClick={this.SearchHistory.bind(
                          this,
                          this.state.cdrid,
                          this.state.cliente,
                        )}
                      >
                        Filtrar
                      </button>
                    </div>
                    <div className="hist-atd__content">
                      <div
                        className={
                          this.state.showHistory
                            ? "hist-atd__search active"
                            : "hist-atd__search"
                        }
                      >
                        <span
                          onClick={(event) => this.handleKeyUp("less")}
                          className="material-icons hist-atd__search-icon"
                        >
                          expand_less
                        </span>
                        <span
                          onClick={(event) => this.handleKeyUp("more")}
                          className="material-icons hist-atd__search-icon"
                        >
                          expand_more
                        </span>
                        <input
                          onChange={(event) =>
                            this.setState({
                              searchText: event.target.value,
                              arrowterm: 0,
                            })
                          }
                          type="text"
                          className="hist-atd__search-input"
                          placeholder="Pesquisar..."
                        />
                        <button
                          onClick={this.SearchInHistory.bind(this)}
                          className="hist-atd__search-btn hist-atd__search-btn--two"
                        >
                          Concluir
                        </button>
                      </div>
                      <div className="hist-atd__channel-info">
                        {/* <img className="hist-atd__channel-info-icon" src={FACEBOOK} alt="" width="20" height="20" /> */}
                        {/* <div className="hist-atd__channel-info-time">Atendimento - 00/00/0000</div> */}
                      </div>
                      <div className="hist-atd__wrapper">
                        <div className="hist-atd__channel pdf">
                          <div className="hist-atd__channel-chat active">
                            {this.state.history.map((history) => (
                              <div
                                key={history.id}
                                className={
                                  history.agente === true
                                    ? "message right"
                                    : "message left"
                                }
                              >
                                {(() => {
                                  dia = history.diaenvio;
                                  mes = history.mesenvio;
                                  ano = history.anoenvio;
                                  mes = meses.indexOf(mes);
                                  dia = dia + " de " + meses[mes - 1];
                                  if (
                                    ano < history.anoenvio ||
                                    ano > history.anoenvio
                                  )
                                    dia = dia + " de " + history.anoenvio;
                                  if (dia != auxdia) {
                                    dia = dia;
                                    auxdia = dia;
                                  } else {
                                    auxdia = dia;
                                    dia = "";
                                  }
                                })()}
                                <div className="time">{dia}</div>
                                <div
                                  className="bubble"
                                  id={"history_" + history.messageid}
                                >
                                  {(() => {
                                    if (history.replyid > 0) {
                                      var text = "";
                                      var array = [];
                                      var posit = "";
                                      checkreply = true;

                                      array = this.state.history.filter(
                                        (msg) =>
                                          parseInt(msg.messageid) ===
                                          parseInt(history.replyid),
                                      );
                                      if (array.length !== 0 && array) {
                                        posit = array[0].author;
                                        if (array[0].mimetypeid !== 1) {
                                          var url = array[0].messagem;
                                          url = url.substring(
                                            url.lastIndexOf(".") + 1,
                                          );
                                          switch (url.toLowerCase()) {
                                            case "jpeg":
                                            case "png":
                                            case "jpg": {
                                              return (
                                                <a
                                                  href={
                                                    "#history_" +
                                                    history.replyid
                                                  }
                                                >
                                                  <div className="reply-message active">
                                                    <div className="reply-message__name">
                                                      {posit === "Me"
                                                        ? "Você"
                                                        : createJSON(
                                                            this.state.cliente,
                                                          )}
                                                    </div>
                                                    <div className="reply-message__text">
                                                      <img
                                                        src={FOTO}
                                                        alt=""
                                                        width="15"
                                                      />{" "}
                                                      Imagem
                                                    </div>
                                                  </div>
                                                </a>
                                              );
                                            }
                                            case "pdf":
                                              return (
                                                <a
                                                  href={
                                                    "#history_" +
                                                    history.replyid
                                                  }
                                                >
                                                  <div className="reply-message active">
                                                    <div className="reply-message__name">
                                                      {posit === "Me"
                                                        ? "Você"
                                                        : createJSON(
                                                            this.state.cliente,
                                                          )}
                                                    </div>
                                                    <div className="reply-message__text">
                                                      <img
                                                        src={DOC}
                                                        alt=""
                                                        width="15"
                                                      />{" "}
                                                      PDF
                                                    </div>
                                                  </div>
                                                </a>
                                              );
                                            case "xls":
                                            case "xlsx":
                                            case "xlsm":
                                            case "doc":
                                            case "docx":
                                            case "ppt":
                                            case "pptx": {
                                              return (
                                                <a
                                                  href={
                                                    "#history_" +
                                                    history.replyid
                                                  }
                                                >
                                                  <div className="reply-message active">
                                                    <div className="reply-message__name">
                                                      {posit === "Me"
                                                        ? "Você"
                                                        : createJSON(
                                                            this.state.cliente,
                                                          )}
                                                    </div>
                                                    <div className="reply-message__text">
                                                      <img
                                                        src={DOC}
                                                        alt=""
                                                        width="15"
                                                      />{" "}
                                                      DOC
                                                    </div>
                                                  </div>
                                                </a>
                                              );
                                            }
                                            case "wav":
                                            case "mp3":
                                            case "ogg":
                                            case "mpeg": {
                                              return (
                                                <a
                                                  href={
                                                    "#history_" +
                                                    history.replyid
                                                  }
                                                >
                                                  <div className="reply-message active">
                                                    <div className="reply-message__name">
                                                      {posit === "Me"
                                                        ? "Você"
                                                        : createJSON(
                                                            this.state.cliente,
                                                          )}
                                                    </div>
                                                    <div className="reply-message__text">
                                                      <img
                                                        src={AUDIO}
                                                        alt=""
                                                        width="12"
                                                      />{" "}
                                                      Áudio
                                                    </div>
                                                  </div>
                                                </a>
                                              );
                                            }
                                            case "mp4": {
                                              return (
                                                <a
                                                  href={
                                                    "#history_" +
                                                    history.replyid
                                                  }
                                                >
                                                  <div className="reply-message active">
                                                    <div className="reply-message__name">
                                                      {posit === "Me"
                                                        ? "Você"
                                                        : createJSON(
                                                            this.state.cliente,
                                                          )}
                                                    </div>
                                                    <div className="reply-message__text">
                                                      <img
                                                        src={VIDEO}
                                                        alt=""
                                                        width="15"
                                                      />{" "}
                                                      Vídeo
                                                    </div>
                                                  </div>
                                                </a>
                                              );
                                            }
                                          }
                                        } else {
                                          text = array[0].messagem;
                                          if (text.length > 200)
                                            text = text.substr(0, 200) + "...";
                                          text = text.replace(/¿/gi, "\n");
                                          text = text.replace(/§/gi, "\r\n");
                                          return (
                                            <a
                                              href={
                                                "#history_" + history.replyid
                                              }
                                            >
                                              <div className="reply-message active">
                                                <div className="reply-message__name">
                                                  {posit === "Me"
                                                    ? "Você"
                                                    : createJSON(
                                                        this.state.cliente,
                                                      )}
                                                </div>
                                                <div className="reply-message__text">
                                                  {text}
                                                </div>
                                              </div>
                                            </a>
                                          );
                                        }
                                      }
                                    }
                                    //}
                                  })()}

                                  <div className="bubble-user-name">
                                    {checkreply === false
                                      ? history.agente === false
                                        ? createJSON(this.state.cliente)
                                        : history.username
                                      : null}
                                  </div>
                                  <div className="text">
                                    {(() => {
                                      let caption = history.caption;
                                      if (
                                        caption == "null" ||
                                        caption == null
                                      ) {
                                        caption = "";
                                      } else {
                                        caption = caption.replace(
                                          /\\n/g,
                                          "\r\n",
                                        );
                                      }
                                      var positmessage1 = "";
                                      var positmessage2 = "";
                                      checkreply = false;
                                      if (history.is_from_agent === true) {
                                        positmessage1 = " right";
                                      }

                                      if (history.mimetypeid == "1") {
                                        var mensagem_tratada = tratarMSG(
                                          history.messagem,
                                        );
                                        mensagem_tratada =
                                          mensagem_tratada.replace(
                                            /\\n/gi,
                                            "\r\n",
                                          );
                                        return (
                                          <div>
                                            <Highlighter
                                              highlightClassName="YourHighlightClass"
                                              searchWords={searchWords}
                                              autoEscape={true}
                                              textToHighlight={mensagem_tratada}
                                              sanitize={latinize}
                                            />
                                            <span className="text__end-spacing"></span>
                                          </div>
                                        );
                                      } else {
                                        if (history.mimetypeid == "2") {
                                          if (
                                            isJson(history.messagem) === true
                                          ) {
                                            let json = JSON.parse(
                                              history.messagem,
                                            );
                                            let options = json.options;
                                            let i = 1;
                                            var opcoes = [];
                                            for (i in options) {
                                              opcoes.push(
                                                i + " - " + options[i][1],
                                              );
                                            }
                                            return (
                                              <div>
                                                <Highlighter
                                                  highlightClassName="YourHighlightClass"
                                                  searchWords={searchWords}
                                                  autoEscape={true}
                                                  textToHighlight={
                                                    json.msg + " \r\n "
                                                  }
                                                  sanitize={latinize}
                                                />
                                                <Highlighter
                                                  highlightClassName="YourHighlightClass"
                                                  searchWords={searchWords}
                                                  autoEscape={true}
                                                  textToHighlight={opcoes.join(
                                                    "  \r\n  ",
                                                  )}
                                                  sanitize={latinize}
                                                />
                                                <span className="text__end-spacing"></span>
                                              </div>
                                            );
                                          } else {
                                            return (
                                              <div>
                                                <Highlighter
                                                  highlightClassName="YourHighlightClass"
                                                  searchWords={searchWords}
                                                  autoEscape={true}
                                                  textToHighlight={
                                                    history.messagem
                                                  }
                                                  sanitize={latinize}
                                                />
                                                <span className="text__end-spacing"></span>
                                              </div>
                                            );
                                          }
                                        } else if (history.mimetypeid == "30") {
                                          if (
                                            isJson(history.messagem) === true
                                          ) {
                                            let json = JSON.parse(
                                              history.messagem,
                                            );
                                            let options = json.options;
                                            let i = 1;
                                            var opcoes = [];
                                            for (i in options) {
                                              opcoes.push(
                                                i + " - " + options[i][1],
                                              );
                                            }
                                            if (json.MSG) {
                                              return (
                                                <div>
                                                  <Highlighter
                                                    highlightClassName="YourHighlightClass"
                                                    searchWords={searchWords}
                                                    autoEscape={true}
                                                    textToHighlight={
                                                      json.MSG + " \r\n "
                                                    }
                                                    sanitize={latinize}
                                                  />
                                                  <Highlighter
                                                    highlightClassName="YourHighlightClass"
                                                    searchWords={searchWords}
                                                    autoEscape={true}
                                                    textToHighlight={opcoes.join(
                                                      "  \r\n  ",
                                                    )}
                                                    sanitize={latinize}
                                                  />
                                                  <span className="text__end-spacing"></span>
                                                </div>
                                              );
                                            } else if (json.URL) {
                                              return (
                                                <div>
                                                  <Highlighter
                                                    highlightClassName="YourHighlightClass"
                                                    searchWords={searchWords}
                                                    autoEscape={true}
                                                    textToHighlight={
                                                      json.URL + " \r\n "
                                                    }
                                                    sanitize={latinize}
                                                  />
                                                  <Highlighter
                                                    highlightClassName="YourHighlightClass"
                                                    searchWords={searchWords}
                                                    autoEscape={true}
                                                    textToHighlight={opcoes.join(
                                                      "  \r\n  ",
                                                    )}
                                                    sanitize={latinize}
                                                  />
                                                  <span className="text__end-spacing"></span>
                                                </div>
                                              );
                                            }
                                          } else {
                                            return (
                                              <div>
                                                <Highlighter
                                                  highlightClassName="YourHighlightClass"
                                                  searchWords={searchWords}
                                                  autoEscape={true}
                                                  textToHighlight={
                                                    history.messagem
                                                  }
                                                  sanitize={latinize}
                                                />
                                                <span className="text__end-spacing"></span>
                                              </div>
                                            );
                                          }
                                        } else if (
                                          history.mimetypeid == "3" ||
                                          history.mimetypeid == "4" ||
                                          history.mimetypeid == "5" ||
                                          history.mimetypeid >= "6"
                                        ) {
                                          let separador =
                                            history.messagem.split(".");
                                          switch (separador[1]) {
                                            case "jpeg":
                                            case "png":
                                            case "PNG":
                                            case "jpg":
                                              return (
                                                <div className="bubble-media">
                                                  <div
                                                    className="bubble-media__image"
                                                    onClick={(e) =>
                                                      this.VerifierImage(
                                                        e,
                                                        connection_platform.type_connect +
                                                          "://" +
                                                          ipcurrent +
                                                          history.messagem,
                                                        "history",
                                                      )
                                                    }
                                                  >
                                                    {this.state.isOpen && (
                                                      <Lightbox
                                                        mainSrc={
                                                          this.state.urlimage
                                                        }
                                                        onCloseRequest={(e) =>
                                                          this.CloseImage(
                                                            e,
                                                            "history",
                                                          )
                                                        }
                                                      />
                                                    )}
                                                    <img
                                                      src={
                                                        connection_platform.type_connect +
                                                        "://" +
                                                        ipcurrent +
                                                        history.messagem
                                                      }
                                                      alt=""
                                                    />
                                                  </div>
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      <img
                                                        className="bubble-media__fileIcon"
                                                        src={JPG}
                                                        alt=""
                                                      />
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize,
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                connection_platform.type_connect +
                                                                "://" +
                                                                ipcurrent +
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                              break;
                                            case "pdf":
                                              return (
                                                <div className="bubble-media">
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      <img
                                                        className="bubble-media__fileIcon"
                                                        src={PDF}
                                                        alt=""
                                                      />
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize,
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                connection_platform.type_connect +
                                                                "://" +
                                                                ipcurrent +
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                              break;
                                            case "xls":
                                            case "xlsx":
                                            case "xlsm":
                                            case "doc":
                                            case "docx":
                                            case "ppt":
                                            case "pptx":
                                              return (
                                                <div className="bubble-media">
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      <img
                                                        className="bubble-media__fileIcon"
                                                        src={XLS}
                                                        alt=""
                                                      />
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize,
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                connection_platform.type_connect +
                                                                "://" +
                                                                ipcurrent +
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                              break;
                                            case "wav":
                                            case "mp3":
                                            case "ogg":
                                            case "mpeg":
                                              return (
                                                <div className="bubble-media">
                                                  <div className="bubble-media__playerBar">
                                                    <audio controls>
                                                      <source
                                                        src={
                                                          connection_platform.type_connect +
                                                          "://" +
                                                          ipcurrent +
                                                          history.messagem
                                                        }
                                                        type="audio/ogg"
                                                      />
                                                      <source
                                                        src={
                                                          connection_platform.type_connect +
                                                          "://" +
                                                          ipcurrent +
                                                          history.messagem
                                                        }
                                                        type="audio/mpeg"
                                                      />
                                                      Your browser.
                                                    </audio>
                                                  </div>
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      <img
                                                        className="bubble-media__fileIcon"
                                                        src={MP3}
                                                        alt=""
                                                      />
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize,
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                connection_platform.type_connect +
                                                                "://" +
                                                                ipcurrent +
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                              break;
                                            case "mp4":
                                              return (
                                                <div className="bubble-media">
                                                  <div className="bubble-media__video">
                                                    <video
                                                      className="bubble-media__video-frame"
                                                      controls
                                                    >
                                                      <source
                                                        className="bubble-media__video-file"
                                                        src={
                                                          connection_platform.type_connect +
                                                          "://" +
                                                          ipcurrent +
                                                          history.messagem
                                                        }
                                                        type="video/mp4"
                                                      />
                                                      Seu navegador nao suporta
                                                      esse tipo de arquivo.
                                                    </video>
                                                  </div>
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      <img
                                                        className="bubble-media__fileIcon"
                                                        src={AVI}
                                                        alt=""
                                                      />
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize,
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                connection_platform.type_connect +
                                                                "://" +
                                                                ipcurrent +
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                              break;
                                            default:
                                              if (
                                                history.messagem.indexOf(
                                                  "https",
                                                ) > -1 &&
                                                history.messagem !== ""
                                              ) {
                                                if (
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 16 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 41
                                                ) {
                                                  return (
                                                    <div className="bubble-media">
                                                      <div className="bubble-media__video">
                                                        <video
                                                          className="bubble-media__video-frame"
                                                          controls
                                                        >
                                                          <source
                                                            className="bubble-media__video-file"
                                                            src={
                                                              history.messagem
                                                            }
                                                            type="video/mp4"
                                                          />
                                                          Seu navegador nao
                                                          suporta esse tipo de
                                                          arquivo.
                                                        </video>
                                                      </div>
                                                      <div className="bubble-media__mediaInfo">
                                                        <span className="bubble-media__fileType">
                                                          <img
                                                            className="bubble-media__fileIcon"
                                                            src={AVI}
                                                            alt=""
                                                          />
                                                        </span>
                                                        <span className="bubble-media__fileName">
                                                          <p className="bubble-media__text">
                                                            Nome do Arquivo
                                                          </p>
                                                          <br />
                                                          <div className="fileinfo__bar">
                                                            <span className="fileinfo__size">
                                                              {dbfileSize(
                                                                history.filesize,
                                                              )}
                                                            </span>{" "}
                                                            •{" "}
                                                            <span className="fileinfo__type">
                                                              {""}
                                                            </span>
                                                          </div>
                                                        </span>
                                                        {(() => {
                                                          if (
                                                            InfoUsers.permdownload ===
                                                            true
                                                          ) {
                                                            return (
                                                              <div className="bubble-media__download">
                                                                <a
                                                                  href={
                                                                    history.messagem
                                                                  }
                                                                  target="_blank"
                                                                  download
                                                                  className="bubble-media__btnDownload"
                                                                >
                                                                  <i className="material-icons">
                                                                    get_app
                                                                  </i>
                                                                </a>
                                                              </div>
                                                            );
                                                          }
                                                        })()}
                                                      </div>
                                                    </div>
                                                  );
                                                } else if (
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 1
                                                ) {
                                                  var mensagem_tratada =
                                                    tratarMSG(history.messagem);
                                                  mensagem_tratada =
                                                    mensagem_tratada.replace(
                                                      /\\n/gi,
                                                      "\r\n",
                                                    );
                                                  return (
                                                    <div>
                                                      <Highlighter
                                                        highlightClassName="YourHighlightClass"
                                                        searchWords={
                                                          searchWords
                                                        }
                                                        autoEscape={true}
                                                        textToHighlight={
                                                          mensagem_tratada
                                                        }
                                                        sanitize={latinize}
                                                      />
                                                      <span className="text__end-spacing"></span>
                                                    </div>
                                                  );
                                                } else if (
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 5 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 7 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 8 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 9 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 10 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 11 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 12 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 13 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 14
                                                ) {
                                                  return (
                                                    <div className="bubble-media">
                                                      <div className="bubble-media__mediaInfo">
                                                        <span className="bubble-media__fileType"></span>
                                                        <span className="bubble-media__fileName">
                                                          <p className="bubble-media__text">
                                                            Nome do Arquivo
                                                          </p>
                                                          <br />
                                                          <div className="fileinfo__bar">
                                                            <span className="fileinfo__size">
                                                              {dbfileSize(
                                                                history.filesize,
                                                              )}
                                                            </span>{" "}
                                                            •{" "}
                                                            <span className="fileinfo__type">
                                                              {""}
                                                            </span>
                                                          </div>
                                                        </span>
                                                        {(() => {
                                                          if (
                                                            InfoUsers.permdownload ===
                                                            true
                                                          ) {
                                                            return (
                                                              <div className="bubble-media__download">
                                                                <a
                                                                  href={
                                                                    history.messagem
                                                                  }
                                                                  target="_blank"
                                                                  download
                                                                  className="bubble-media__btnDownload"
                                                                >
                                                                  <i className="material-icons">
                                                                    get_app
                                                                  </i>
                                                                </a>
                                                              </div>
                                                            );
                                                          }
                                                        })()}
                                                      </div>
                                                    </div>
                                                  );
                                                } else if (
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 4 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 6 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 15 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 17 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 21 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 25 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 26 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 27 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 28 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 40
                                                ) {
                                                  return (
                                                    <div className="bubble-media">
                                                      <div className="bubble-media__playerBar">
                                                        <audio controls>
                                                          <source
                                                            src={
                                                              history.messagem
                                                            }
                                                            type="audio/ogg"
                                                          />
                                                          <source
                                                            src={
                                                              history.messagem
                                                            }
                                                            type="audio/mpeg"
                                                          />
                                                          Your browser.
                                                        </audio>
                                                      </div>
                                                      <div className="bubble-media__mediaInfo">
                                                        <span className="bubble-media__fileType">
                                                          {/* <img className="bubble-media__fileIcon" src={MP3} alt="" /> */}
                                                        </span>
                                                        <span className="bubble-media__fileName">
                                                          <p className="bubble-media__text">
                                                            Nome do Arquivo
                                                          </p>
                                                          <br />
                                                          <div className="fileinfo__bar">
                                                            <span className="fileinfo__size">
                                                              {dbfileSize(
                                                                history.filesize,
                                                              )}
                                                            </span>{" "}
                                                            •{" "}
                                                            <span className="fileinfo__type">
                                                              {""}
                                                            </span>
                                                          </div>
                                                        </span>
                                                        {(() => {
                                                          if (
                                                            InfoUsers.permdownload ===
                                                            true
                                                          ) {
                                                            return (
                                                              <div className="bubble-media__download">
                                                                <a
                                                                  href={
                                                                    history.messagem
                                                                  }
                                                                  target="_blank"
                                                                  download
                                                                  className="bubble-media__btnDownload"
                                                                >
                                                                  <i className="material-icons">
                                                                    get_app
                                                                  </i>
                                                                </a>
                                                              </div>
                                                            );
                                                          }
                                                        })()}
                                                      </div>
                                                    </div>
                                                  );
                                                } else if (
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 3 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 18 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 19 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 20 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 22 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 23 ||
                                                  parseInt(
                                                    history.mimetypeid,
                                                  ) === 24
                                                ) {
                                                  return (
                                                    <div className="bubble-media">
                                                      <div
                                                        className="bubble-media__image"
                                                        onClick={(e) =>
                                                          this.VerifierImage(
                                                            e,
                                                            history.messagem,
                                                            "history",
                                                          )
                                                        }
                                                      >
                                                        {this.state.isOpen && (
                                                          <Lightbox
                                                            mainSrc={
                                                              this.state
                                                                .urlimage
                                                            }
                                                            onCloseRequest={(
                                                              e,
                                                            ) =>
                                                              this.CloseImage(
                                                                e,
                                                                "history",
                                                              )
                                                            }
                                                          />
                                                        )}
                                                        <img
                                                          src={history.messagem}
                                                          alt=""
                                                        />
                                                      </div>
                                                      <div className="bubble-media__mediaInfo">
                                                        <span className="bubble-media__fileType"></span>
                                                        <span className="bubble-media__fileName">
                                                          <p className="bubble-media__text">
                                                            Nome do Arquivo
                                                          </p>
                                                          <br />
                                                          <div className="fileinfo__bar">
                                                            <span className="fileinfo__size">
                                                              {dbfileSize(
                                                                history.filesize,
                                                              )}
                                                            </span>{" "}
                                                            •{" "}
                                                            <span className="fileinfo__type">
                                                              {""}
                                                            </span>
                                                          </div>
                                                        </span>
                                                        {(() => {
                                                          if (
                                                            InfoUsers.permdownload ===
                                                            true
                                                          ) {
                                                            return (
                                                              <div className="bubble-media__download">
                                                                <a
                                                                  href={
                                                                    history.messagem
                                                                  }
                                                                  target="_blank"
                                                                  download
                                                                  className="bubble-media__btnDownload"
                                                                >
                                                                  <i className="material-icons">
                                                                    get_app
                                                                  </i>
                                                                </a>
                                                              </div>
                                                            );
                                                          }
                                                        })()}
                                                      </div>
                                                    </div>
                                                  );
                                                }
                                              }
                                          }
                                        }
                                      }
                                    })()}
                                  </div>
                                  <div className="text">
                                    {(() => {
                                      let caption = history.caption;
                                      if (
                                        caption == "null" ||
                                        caption == null
                                      ) {
                                        caption = "";
                                      } else {
                                        caption = caption.replace(
                                          /\\n/g,
                                          "\r\n",
                                        );
                                      }
                                      return caption;
                                    })()}
                                  </div>
                                  <div className="bubble__info-content">
                                    <div className="fav fav--inside fav--right">
                                      {/* <i className="material-icons fav-icon">star_border</i> */}
                                    </div>
                                    <div className="bubble__info-content__time">
                                      {history.horaenvio}
                                    </div>

                                    {(() => {
                                      if (history.agente === true) {
                                        if (
                                          parseInt(history.mon_type_id) !== 2
                                        ) {
                                          if (history.dateerror !== null)
                                            return (
                                              <div
                                                className={
                                                  "message-info message-info--error"
                                                }
                                              >
                                                <i className="material-icons">
                                                  error
                                                </i>
                                              </div>
                                            );
                                          else if (history.dateread !== null)
                                            return (
                                              <div
                                                className={
                                                  "message-info message-info--visto"
                                                }
                                              >
                                                <i className="material-icons">
                                                  done_all
                                                </i>
                                              </div>
                                            );
                                          else if (
                                            history.datedelivered !== null
                                          )
                                            return (
                                              <div className={"message-info"}>
                                                <i className="material-icons">
                                                  done_all
                                                </i>
                                              </div>
                                            );
                                          else
                                            return (
                                              <div className={"message-info"}>
                                                <i className="material-icons">
                                                  done
                                                </i>
                                              </div>
                                            );
                                        } else {
                                          return (
                                            <div
                                              className={
                                                "message-info message-info--visto"
                                              }
                                            >
                                              <i className="material-icons">
                                                done_all
                                              </i>
                                            </div>
                                          );
                                        }
                                      }
                                    })()}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </main>

                  <button
                    className="hist-atd__fab"
                    onClick={this.SearchInHistory.bind(this)}
                  >
                    <i className="material-icons">search</i>
                  </button>

                  <div className="modal__content__form__group modal__content__form__group--col-1">
                    <a
                      className="modal__content__form__group__button modal__content__form__group__button--text"
                      data-micromodal-close
                    >
                      <i className="material-icons" data-micromodal-close>
                        arrow_back
                      </i>
                      Voltar
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </>
        </div>
        <div
          style={{
            position: "absolute",
            right: "-9999999999999999999999999px",
            top: 0,
          }}
        >
          <PDFExport
            ref={(component) => (this.pdfExportComponent = component)}
            paperSize="A4"
          >
            <PdfDocument
              history={this.state.history}
              cliente={this.state.cliente}
              datapdfinit={this.state.datapdfinit}
              datapdfend={this.state.datapdfend}
              numero={this.state.clientpdf}
            />
          </PDFExport>
        </div>
        <div
          className="modal micromodal-slide"
          id="modal__agenda-pf-usuario-detalhes-history"
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal__overlay" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__agenda-pf-usuario-detalhes__title"
            >
              <header className="modal__header">
                <h2
                  className="modal__title"
                  id="modal__agenda-pf-usuario-detalhes__title"
                >
                  {TELAPJPF}
                </h2>
                <button
                  className="modal__close"
                  aria-label="Close modal"
                  onClick={(event) =>
                    this.CancelMenosCampos(
                      event,
                      "modal__agenda-pf-usuario-detalhes",
                    )
                  }
                ></button>
              </header>
              <main
                className="modal__content"
                id="modal__agenda-pf-usuario-detalhes__content"
              >
                <div className="modal__content__user-details__header">
                  <div className="modal__content__user-details__header__info">
                    {(() => {
                      if (this.state.pathfile) {
                        if (this.state.pathfile.length === 1) {
                          return (
                            <div className="photo-container-one active">
                              <Topover
                                interactive={true}
                                content={this.renderPopoverPhoto(
                                  this,
                                  IPCurrent.ip,
                                  this.state.pathfile[0].pathfile,
                                )}
                              >
                                <div className="photo-container-one__item">
                                  <img
                                    src={
                                      this.state.pathfile[0].pathfile ===
                                        null || ""
                                        ? DEFAULT
                                        : connection_platform.type_connect +
                                          "://" +
                                          ipcurrent +
                                          this.state.pathfile[0].pathfile
                                    }
                                  />
                                  <div className="photo-container__list__item__social">
                                    {(() => {
                                      if (
                                        this.state.pathfile[0].midiaid === 1
                                      ) {
                                        return <img src={CALLCHAT} />;
                                      } else if (
                                        this.state.pathfile[0].midiaid === 3
                                      ) {
                                        return <img src={MIDIAWEB} />;
                                      } else if (
                                        this.state.pathfile[0].midiaid === 4
                                      ) {
                                        return <img src={MIDIAFACE} />;
                                      } else if (
                                        this.state.pathfile[0].midiaid === 5
                                      ) {
                                        return <img src={MIDIAZAP} />;
                                      }
                                    })()}
                                  </div>
                                </div>
                              </Topover>
                            </div>
                          );
                        } else {
                          return (
                            <div className="photo-container active">
                              {this.state.pathfile.slice(0, 1).map((path) => (
                                <div className="photo-container__img">
                                  <div className="photo-container__img__s2"></div>
                                  <div className="photo-container__img__s1"></div>
                                  <div className="wrapper-photo">
                                    <img
                                      src={
                                        path.pathfile === null || ""
                                          ? DEFAULT
                                          : connection_platform.type_connect +
                                            "://" +
                                            ipcurrent +
                                            path.pathfile
                                      }
                                    />
                                    <div className="photo-container__list__item__social">
                                      {(() => {
                                        if (path.midiaid === 1) {
                                          return <img src={CALLCHAT} />;
                                        } else if (path.midiaid === 3) {
                                          return <img src={MIDIAWEB} />;
                                        } else if (path.midiaid === 4) {
                                          return <img src={MIDIAFACE} />;
                                        } else if (path.midiaid === 5) {
                                          return <img src={MIDIAZAP} />;
                                        }
                                      })()}
                                    </div>
                                  </div>
                                </div>
                              ))}
                              <div className="photo-container__list">
                                {this.state.pathfile
                                  .slice(1, this.state.pathfile.length)
                                  .map((path) => (
                                    <>
                                      <div className="photo-container__list__item">
                                        <img
                                          src={
                                            path.pathfile === null || ""
                                              ? DEFAULT
                                              : connection_platform.type_connect +
                                                "://" +
                                                ipcurrent +
                                                path.pathfile
                                          }
                                        />
                                        <div className="photo-container__list__item__social">
                                          {(() => {
                                            if (path.midiaid === 1) {
                                              return <img src={CALLCHAT} />;
                                            } else if (path.midiaid === 3) {
                                              return <img src={MIDIAWEB} />;
                                            } else if (path.midiaid === 4) {
                                              return <img src={MIDIAFACE} />;
                                            } else if (path.midiaid === 5) {
                                              return <img src={MIDIAZAP} />;
                                            }
                                          })()}
                                        </div>
                                      </div>
                                    </>
                                  ))}
                              </div>
                            </div>
                          );
                        }
                      } else {
                        return (
                          <div className="modal__content__user-details__header__info__photo">
                            person
                          </div>
                        );
                      }
                    })()}
                    <div className="modal__content__user-details__header__info__name">
                      {this.state.person}
                    </div>
                  </div>
                  <div className="modal__content__user-details__header__networks">
                    <div className="modal__content__user-details__header__networks__title">
                      Falar com cliente:
                    </div>
                    <a
                      href="#"
                      className="modal__content__tabs__body__tab__result__body__channels__channel"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                      >
                        <path d="M0,0H20V20H0Z" fill="none" />
                        <path
                          className="grey-mode"
                          d="M18.82,14.632A10.572,10.572,0,0,1,15.5,14.1a.95.95,0,0,0-.95.223L12.5,16.372a14,14,0,0,1-6.133-6.133L8.416,8.178a.893.893,0,0,0,.232-.931,10.572,10.572,0,0,1-.531-3.322A.933.933,0,0,0,7.188,3H3.924A.933.933,0,0,0,3,3.931a15.819,15.819,0,0,0,15.822,15.82.933.933,0,0,0,.929-.931V15.556A.933.933,0,0,0,18.82,14.632Zm-.931-3.264h1.86A8.376,8.376,0,0,0,11.375,3V4.86a6.509,6.509,0,0,1,6.514,6.514Zm-3.723,0h1.86a4.655,4.655,0,0,0-4.652-4.645v1.86a2.788,2.788,0,0,1,2.792,2.792Z"
                          transform="translate(-1.375 -1.375)"
                          fill="#005daa"
                        />
                      </svg>
                    </a>
                    <a
                      href="#"
                      className="modal__content__tabs__body__tab__result__body__channels__channel"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                      >
                        <path
                          className="grey-mode"
                          d="M-67.705-1207.71a9.912,9.912,0,0,1-5.5-1.656l-3.843,1.231,1.246-3.715a9.885,9.885,0,0,1-1.9-5.859,10.012,10.012,0,0,1,10-10,10.011,10.011,0,0,1,10,10A10.009,10.009,0,0,1-67.705-1207.71Zm-3.769-15.43a1.458,1.458,0,0,0-1.024.36l-.029.03a3.2,3.2,0,0,0-1,2.4,5.363,5.363,0,0,0,1.17,2.991l.018.024c.011.014.03.041.057.081l.006.008a11.887,11.887,0,0,0,4.918,4.31,8.551,8.551,0,0,0,2.934.819,2.694,2.694,0,0,0,.571-.065,2.819,2.819,0,0,0,1.96-1.411,2.507,2.507,0,0,0,.173-1.4c-.055-.094-.185-.157-.381-.251l-.014-.007-.164-.08c-.216-.108-1.713-.848-1.991-.947a.735.735,0,0,0-.252-.049.564.564,0,0,0-.468.268l-.092.13a10.08,10.08,0,0,1-.689.905.556.556,0,0,1-.414.169.752.752,0,0,1-.288-.059l-.074-.03a7.346,7.346,0,0,1-2.271-1.416,8.959,8.959,0,0,1-1.62-2.016.455.455,0,0,1,.108-.61l.009-.011c.093-.119.183-.215.279-.316.053-.056.1-.11.155-.168l.016-.018a1.62,1.62,0,0,0,.308-.439.613.613,0,0,0-.043-.544c-.049-.1-.343-.817-.6-1.448l0-.011-.044-.107-.246-.6c-.194-.456-.336-.48-.637-.491l-.1,0C-71.314-1223.136-71.391-1223.14-71.474-1223.14Z"
                          transform="translate(77.71 1227.71)"
                          fill="#25d366"
                        />
                      </svg>
                    </a>
                    <a
                      href="#"
                      className="modal__content__tabs__body__tab__result__body__channels__channel"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20.009"
                        viewBox="0 0 20 20.009"
                      >
                        <path
                          d="M0,.961V19.047a.961.961,0,0,0,.961.961h9.693V12.283h-2.6V9.126h2.6V6.475a3.49,3.49,0,0,1,3.49-3.49h2.722V5.821H14.917a1.112,1.112,0,0,0-1.111,1.111V9.126h3.007L16.4,12.283H13.8v7.726h5.237A.961.961,0,0,0,20,19.047V.961A.961.961,0,0,0,19.039,0H.953A.959.959,0,0,0,0,.961Z"
                          fill="#3b5998"
                          className="grey-mode"
                        />
                      </svg>
                    </a>
                    <a
                      href="mailto:suporte@ingenium-systems.com.br"
                      className="modal__content__tabs__body__tab__result__body__channels__channel"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20,4H4A2,2,0,0,0,2.01,6L2,18a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V6A2.006,2.006,0,0,0,20,4Zm0,4-8,5L4,8V6l8,5,8-5Z"
                          fill="#005daa"
                          className="grey-mode"
                        />
                      </svg>
                    </a>
                    <a
                      href="#"
                      className="modal__content__tabs__body__tab__result__body__channels__channel disable"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20.049"
                        height="20.049"
                        viewBox="0 0 20.049 20.049"
                      >
                        <circle
                          className="grey-mode"
                          cx="10.024"
                          cy="10.024"
                          r="10.024"
                          fill="#08c"
                        />
                        <path
                          d="M100.412,107.636a.334.334,0,0,0-.329-.027l-10.772,5.014a.527.527,0,0,0,.012.96l9.931,4.325a.532.532,0,0,0,.743-.448l.561-9.529A.334.334,0,0,0,100.412,107.636Z"
                          transform="translate(-85.522 -103.365)"
                          fill="#e5e5e5"
                        />
                        <path
                          d="M171.631,115.676l.671,4.487,7.455-11.73Z"
                          transform="translate(-164.91 -104.186)"
                          fill="#b7bec5"
                        />
                        <path
                          d="M100.083,107.613l-10.772,5.014a.527.527,0,0,0,.012.96l2.919,1.271,8.127-7.244A.334.334,0,0,0,100.083,107.613Z"
                          transform="translate(-85.522 -103.369)"
                          fill="#fff"
                        />
                        <path
                          d="M189.659,116.354l-.887,3.808,7.456-11.73Z"
                          transform="translate(-181.38 -104.186)"
                          fill="#fff"
                        />
                        <path
                          d="M218.03,108.456a.328.328,0,0,0-.043-.024l-6.569,7.922,5.454,2.375a.532.532,0,0,0,.743-.448l.561-9.529A.334.334,0,0,0,218.03,108.456Z"
                          transform="translate(-203.139 -104.186)"
                          fill="#fff"
                        />
                      </svg>
                    </a>
                    <a
                      href="#"
                      className="modal__content__tabs__body__tab__result__body__channels__channel disable"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24.615"
                        height="20"
                        viewBox="0 0 24.615 20"
                      >
                        <path
                          className="grey-mode"
                          d="M24.615,50.368a10.521,10.521,0,0,1-2.908.8,5.018,5.018,0,0,0,2.22-2.789,10.085,10.085,0,0,1-3.2,1.222A5.046,5.046,0,0,0,12,53.048a5.2,5.2,0,0,0,.117,1.151,14.284,14.284,0,0,1-10.4-5.278,5.048,5.048,0,0,0,1.551,6.745,4.984,4.984,0,0,1-2.28-.622V55.1a5.07,5.07,0,0,0,4.043,4.958,5.037,5.037,0,0,1-1.323.166,4.462,4.462,0,0,1-.955-.086,5.094,5.094,0,0,0,4.715,3.515A10.14,10.14,0,0,1,1.208,65.8,9.453,9.453,0,0,1,0,65.735,14.207,14.207,0,0,0,7.742,68,14.264,14.264,0,0,0,22.1,53.64c0-.223-.008-.438-.018-.652A10.067,10.067,0,0,0,24.615,50.368Z"
                          transform="translate(0 -48)"
                          fill="#1da1f2"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="modal__content__user-details__content">
                  <form action="" className="modal__content__form">
                    <div className="modal__content__form__group modal__content__form__group--col-3">
                      <label
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--nomecompleto"
                      >
                        Nome Completo:
                      </label>
                      <div className="modal__content__form__group__input-line">
                        <i className="material-icons">person</i>
                        <input
                          disabled={this.state.disabled}
                          type="text"
                          onChange={this.ChangeDisplayname.bind(this)}
                          name="nomecompleto"
                          ref={(input) => (this.name = input)}
                          className="modal__content__form__group__input"
                          id="modal__content__form__group__label--nomecompleto"
                        />
                        <div id="msg_erro7" className="invalid-feedback">
                          Mensagem
                        </div>
                      </div>
                    </div>

                    <div className="modal__content__form__group modal__content__form__group--col-3">
                      <label
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--nomedeapresentacao"
                      >
                        Nome de Apresentação:
                      </label>
                      <div className="modal__content__form__group__input-line">
                        <i className="material-icons">person</i>
                        <input
                          disabled={this.state.disabled}
                          type="text"
                          name="displayname"
                          ref={(input) => (this.displayname = input)}
                          className="modal__content__form__group__input"
                          id="modal__content__form__group__label--nomedeapresentacao"
                        />
                        <div id="msg_erro8" className="invalid-feedback">
                          Mensagem
                        </div>
                      </div>
                    </div>

                    <div className="modal__content__form__group modal__content__form__group--col-2">
                      <label
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--contatode"
                      >
                        Contato de:
                      </label>
                      <Select
                        isDisabled={this.state.disabled}
                        value={this.state.contatode}
                        onChange={this.SelectContato.bind(this)}
                        name="contatode"
                        className="modal__content__form__group__input"
                        id="modal__content__form__group__label--empresa"
                        options={options}
                      />
                      <div id="msg_erro8" className="invalid-feedback">
                        Mensagem
                      </div>
                    </div>

                    <div className="modal__content__form__group modal__content__form__group--col-6">
                      <label
                        className="modal__content__form__group__label"
                        htmlFor="modal__content__form__group__label--email"
                      >
                        E-mail:
                      </label>
                      <div className="modal__content__form__group__input-line">
                        <i className="material-icons">email</i>
                        <input
                          disabled={this.state.disabled}
                          type="email"
                          ref={(input) => (this.email = input)}
                          name="email"
                          className="modal__content__form__group__input"
                          id="modal__content__form__group__label--email"
                        />
                      </div>
                    </div>

                    <div className="modal__content__form__group modal__content__form__group--col-2">
                      <div className="modal__content__form__group__title">
                        Esse contato é particular?
                      </div>
                      <div className="modal__content__form__group__radios">
                        <div className="modal__content__form__group__radios__option">
                          <input
                            disabled={this.state.disabled}
                            type="radio"
                            onChange={this.ContactPrivate.bind(
                              this,
                              InfoUsers.id,
                            )}
                            defaultChecked={
                              this.state.private != "" ? "checked" : ""
                            }
                            name="particular"
                            id="modal__content__form__group__radios__option--sim"
                            className="modal__content__form__group__radios__option__input"
                            value="sim"
                          />
                          <label
                            htmlFor="modal__content__form__group__radios__option--sim"
                            className="modal__content__form__group__radios__option__label"
                          >
                            Sim
                          </label>
                        </div>
                        <div className="modal__content__form__group__radios__option">
                          <input
                            disabled={this.state.disabled}
                            type="radio"
                            onChange={this.ContactPrivate.bind(this, null)}
                            defaultChecked={
                              this.state.private === "" ||
                              this.state.private === undefined
                                ? ""
                                : "checked"
                            }
                            name="particular"
                            id="modal__content__form__group__radios__option--nao"
                            className="modal__content__form__group__radios__option__input"
                            value="nao"
                          />
                          <label
                            htmlFor="modal__content__form__group__radios__option--nao"
                            className="modal__content__form__group__radios__option__label"
                          >
                            Não
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* <!-- CONTATOS --> */}
                    <div className="modal__content__tabs__body__tab__result modal__content__tabs__body__tab__result--full-width">
                      <div className="modal__content__form__group--small modal__content__form__group--col-8">
                        <label className="modal__content__form__group__label modal__content__form__group__label--small">
                          Contatos:
                        </label>
                      </div>

                      {this.state.numberscontact.map((numbers) => (
                        <div
                          className="modal__content__form__row"
                          key={numbers.idphone}
                        >
                          <div className="modal__content__form__group modal__content__form__group--col-2">
                            <div className="modal__content__form__group__input-line">
                              <select
                                disabled
                                name="contadode"
                                id="modal__content__form__group__label--tipo"
                              >
                                <option value="2">Telefone</option>
                                <option value="1">Facebook</option>
                                <option value="3">Linkedin</option>
                                <option value="4">Instagram</option>
                              </select>
                            </div>
                          </div>
                          <div className="modal__content__form__group modal__content__form__group--col-1">
                            <a
                              href="#"
                              className="info"
                              data-tippy-placement="right"
                              data-tooltip="País"
                              data-template="flags"
                            >
                              <div
                                className="new-select-with-icons new-select-with-icons--line"
                                tabIndex="1"
                              >
                                <div className="new-select-with-icons__option new-select-with-icons__selected">
                                  <div className="new-select-with-icons__option__icon">
                                    <img src={FLAG} width="100%" alt="" />
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div className="modal__content__form__group modal__content__form__group--col-2">
                            <div className="modal__content__form__group__input-line">
                              <i className="material-icons">call</i>
                              <InputMask
                                disabled={this.state.disabled}
                                style={{
                                  color:
                                    numbers.exist === true ? "#cc0033" : "",
                                }}
                                onChange={(event) =>
                                  this.EditNumber(event, numbers.idphone)
                                }
                                defaultValue={numbers.number}
                                type="text"
                                mask="(99) 99999-9999"
                                id={"telefone" + numbers.idphone}
                                name={"telefone" + numbers.idphone}
                                className="modal__content__form__group__input"
                                // id="modal__content__form__group__label--telefone"
                              />
                            </div>
                          </div>
                          <div className="modal__content__form__group modal__content__form__group--col-2">
                            <div className="modal__content__form__group__input-line">
                              {(() => {
                                var typeN = parseInt(numbers.phonetypeid);
                                return (
                                  <select
                                    disabled={this.state.disabled}
                                    onChange={(event) =>
                                      this.EditTypeNumber(
                                        event,
                                        numbers.idphone,
                                      )
                                    }
                                    name="contadode"
                                    value={typeN}
                                    id="modal__content__form__group__label--tipo"
                                  >
                                    {typenumbers.map((type) => (
                                      <option
                                        value={type.value}
                                        label={type.label}
                                      >
                                        {type.label}
                                      </option>
                                    ))}
                                  </select>
                                );
                              })()}
                            </div>
                          </div>

                          {(() => {
                            if (this.state.disabled === false) {
                              return (
                                <div className="modal__content__form__group modal__content__form__group--col-1">
                                  <div className="modal__content__form__group__duplicate-btns">
                                    <a
                                      href="#"
                                      onClick={(event) =>
                                        this.concatNumberDel(
                                          event,
                                          numbers.idphone,
                                        )
                                      }
                                      className="modal__content__form__group__duplicate-btns__btn"
                                    >
                                      <div className="material-icons">
                                        remove_circle_outline
                                      </div>
                                    </a>
                                    <a
                                      href="#"
                                      onClick={(event) => this.AddNumber(event)}
                                      className="modal__content__form__group__duplicate-btns__btn"
                                    >
                                      <div className="material-icons">
                                        control_point
                                      </div>
                                    </a>
                                  </div>
                                </div>
                              );
                            }
                          })()}

                          {(() => {
                            if (numbers.exist === true) {
                              return (
                                <span style={{ color: "#cc0033" }}>
                                  Este número já existe
                                </span>
                              );
                            }
                          })()}

                          <div className="modal__content__form__group modal__content__form__group--col-2"></div>

                          <div className="modal__content__form__group--small modal__content__form__group--col-4">
                            <div className="checkbox margin-left">
                              {/* <ul className="checkbox__row">
                                    <li>
                                        <input className="checkbox__row__input no-margin" disabled={this.state.disabled} defaultChecked="checked"  id="checkbox-111" type="checkbox" value="whatsapp" />
                                        <label htmlFor="checkbox-111">Whatsapp</label>
                                    </li>

                                    <li>
                                        <input className="checkbox__row__input no-margin" disabled={this.state.disabled} id="checkbox-222" type="checkbox" value="telegram" />
                                        <label htmlFor="checkbox-222">Telegram</label>
                                    </li>
                                    
                                    </ul>   */}
                            </div>
                          </div>
                        </div>
                      ))}
                      {/* <!-- END ADD CONTATO --> */}
                    </div>
                    {/* <!-- fim contato --> */}

                    <div className="modal__content__form__group modal__content__form__group--col-5">
                      <a
                        onClick={(event) =>
                          this.ShowModal(
                            event,
                            "modal__agenda-pf-usuario-detalhes-mais-campos-history",
                          )
                        }
                        className="modal__content__form__group__button modal__content__form__group__button--text"
                      >
                        <i className="material-icons">visibility</i> Visualizar
                        mais campos
                      </a>
                    </div>
                    {(() => {
                      if (this.state.disabled === true) {
                        return (
                          <div className="modal__content__form__group modal__content__form__group--col-2">
                            <a
                              onClick={this.ButtonEdit.bind(
                                this,
                                false,
                                "edit",
                              )}
                              className="modal__content__form__group__button"
                            >
                              Editar
                            </a>
                          </div>
                        );
                      } else if (
                        this.state.disabled === false &&
                        this.state.module === "edit"
                      ) {
                        return (
                          <div className="modal__content__form__group modal__content__form__group--col-2">
                            <a
                              onClick={(event) =>
                                this.updateContact(
                                  event,
                                  this.state.contactid,
                                  this.state.numberscontact,
                                  InfoUsers.id,
                                )
                              }
                              className="modal__content__form__group__button"
                            >
                              Salvar alterações
                            </a>
                          </div>
                        );
                      } else {
                        return (
                          <div className="modal__content__form__group modal__content__form__group--col-2">
                            <a
                              onClick={(event) =>
                                this.InsertContact(
                                  event,
                                  this.state.numberscontact,
                                  InfoUsers.id,
                                )
                              }
                              className="modal__content__form__group__button"
                            >
                              Adicionar
                            </a>
                          </div>
                        );
                      }
                    })()}
                    <div className="modal__content__form__group modal__content__form__group--col-1">
                      <a
                        onClick={(event) => this.CancelMenosCampos(event)}
                        className="modal__content__form__group__button modal__content__form__group__button--white"
                      >
                        Cancelar
                      </a>
                    </div>
                  </form>
                </div>
              </main>
            </div>
          </div>
        </div>
        <div
          className="modal micromodal-slide"
          id="modal__agenda-pf-usuario-detalhes-mais-campos-history"
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal__overlay" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__agenda-pf-inserir-contato-mais-campos__title"
            >
              <header className="modal__header">
                <h2
                  className="modal__title"
                  id="modal__agenda-pf-inserir-contato-mais-campos__title"
                >
                  {TELAPJPF}
                </h2>
                <button
                  className="modal__close"
                  aria-label="Close modal"
                  onClick={(event) =>
                    this.ExitModal(
                      event,
                      "modal__agenda-pf-usuario-detalhes-mais-campos",
                    )
                  }
                ></button>
              </header>
              <main
                className="modal__content"
                id="modal__agenda-pf-inserir-contato__content"
              >
                <div className="modal__content__user-details__header">
                  <div className="modal__content__user-details__header__info">
                    {(() => {
                      if (this.state.pathfile) {
                        if (this.state.pathfile.length === 1) {
                          return (
                            <div className="photo-container-one active">
                              <Topover
                                interactive={true}
                                content={this.renderPopoverPhoto(
                                  this,
                                  IPCurrent.ip,
                                  this.state.pathfile[0].pathfile,
                                )}
                              >
                                <div className="photo-container-one__item">
                                  <img
                                    src={
                                      this.state.pathfile[0].pathfile ===
                                        null || ""
                                        ? DEFAULT
                                        : connection_platform.type_connect +
                                          "://" +
                                          ipcurrent +
                                          this.state.pathfile[0].pathfile
                                    }
                                  />
                                  <div className="photo-container__list__item__social">
                                    {(() => {
                                      if (
                                        this.state.pathfile[0].midiaid === 1
                                      ) {
                                        return <img src={CALLCHAT} />;
                                      } else if (
                                        this.state.pathfile[0].midiaid === 3
                                      ) {
                                        return <img src={MIDIAWEB} />;
                                      } else if (
                                        this.state.pathfile[0].midiaid === 4
                                      ) {
                                        return <img src={MIDIAFACE} />;
                                      } else if (
                                        this.state.pathfile[0].midiaid === 5
                                      ) {
                                        return <img src={MIDIAZAP} />;
                                      }
                                    })()}
                                  </div>
                                </div>
                              </Topover>
                            </div>
                          );
                        } else {
                          return (
                            <div className="photo-container active">
                              {this.state.pathfile.slice(0, 1).map((path) => (
                                <div className="photo-container__img">
                                  <div className="photo-container__img__s2"></div>
                                  <div className="photo-container__img__s1"></div>
                                  <div className="wrapper-photo">
                                    <img
                                      src={
                                        path.pathfile === null || ""
                                          ? DEFAULT
                                          : connection_platform.type_connect +
                                            "://" +
                                            ipcurrent +
                                            path.pathfile
                                      }
                                    />
                                    <div className="photo-container__list__item__social">
                                      {(() => {
                                        if (path.midiaid === 1) {
                                          return <img src={CALLCHAT} />;
                                        } else if (path.midiaid === 3) {
                                          return <img src={MIDIAWEB} />;
                                        } else if (path.midiaid === 4) {
                                          return <img src={MIDIAFACE} />;
                                        } else if (path.midiaid === 5) {
                                          return <img src={MIDIAZAP} />;
                                        }
                                      })()}
                                    </div>
                                  </div>
                                </div>
                              ))}
                              <div className="photo-container__list">
                                {this.state.pathfile
                                  .slice(1, this.state.pathfile.length)
                                  .map((path) => (
                                    <>
                                      <div className="photo-container__list__item">
                                        <img
                                          src={
                                            path.pathfile === null || ""
                                              ? DEFAULT
                                              : connection_platform.type_connect +
                                                "://" +
                                                ipcurrent +
                                                path.pathfile
                                          }
                                        />
                                        <div className="photo-container__list__item__social">
                                          {(() => {
                                            if (path.midiaid === 1) {
                                              return <img src={CALLCHAT} />;
                                            } else if (path.midiaid === 3) {
                                              return <img src={MIDIAWEB} />;
                                            } else if (path.midiaid === 4) {
                                              return <img src={MIDIAFACE} />;
                                            } else if (path.midiaid === 5) {
                                              return <img src={MIDIAZAP} />;
                                            }
                                          })()}
                                        </div>
                                      </div>
                                    </>
                                  ))}
                              </div>
                            </div>
                          );
                        }
                      } else {
                        return (
                          <div className="modal__content__user-details__header__info__photo">
                            person
                          </div>
                        );
                      }
                    })()}
                  </div>
                  <div className="modal__content__user-details__header__networks">
                    <div className="modal__content__user-details__header__networks__title">
                      Falar com cliente:
                    </div>
                    <a
                      href="#"
                      className="modal__content__user-details__header__networks__network"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                      >
                        <path d="M0,0H20V20H0Z" fill="none" />
                        <path
                          className="grey-mode"
                          d="M18.82,14.632A10.572,10.572,0,0,1,15.5,14.1a.95.95,0,0,0-.95.223L12.5,16.372a14,14,0,0,1-6.133-6.133L8.416,8.178a.893.893,0,0,0,.232-.931,10.572,10.572,0,0,1-.531-3.322A.933.933,0,0,0,7.188,3H3.924A.933.933,0,0,0,3,3.931a15.819,15.819,0,0,0,15.822,15.82.933.933,0,0,0,.929-.931V15.556A.933.933,0,0,0,18.82,14.632Zm-.931-3.264h1.86A8.376,8.376,0,0,0,11.375,3V4.86a6.509,6.509,0,0,1,6.514,6.514Zm-3.723,0h1.86a4.655,4.655,0,0,0-4.652-4.645v1.86a2.788,2.788,0,0,1,2.792,2.792Z"
                          transform="translate(-1.375 -1.375)"
                          fill="#005daa"
                        />
                      </svg>
                    </a>
                    <a
                      href="#"
                      className="modal__content__user-details__header__networks__network"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                      >
                        <path
                          className="grey-mode"
                          d="M-67.705-1207.71a9.912,9.912,0,0,1-5.5-1.656l-3.843,1.231,1.246-3.715a9.885,9.885,0,0,1-1.9-5.859,10.012,10.012,0,0,1,10-10,10.011,10.011,0,0,1,10,10A10.009,10.009,0,0,1-67.705-1207.71Zm-3.769-15.43a1.458,1.458,0,0,0-1.024.36l-.029.03a3.2,3.2,0,0,0-1,2.4,5.363,5.363,0,0,0,1.17,2.991l.018.024c.011.014.03.041.057.081l.006.008a11.887,11.887,0,0,0,4.918,4.31,8.551,8.551,0,0,0,2.934.819,2.694,2.694,0,0,0,.571-.065,2.819,2.819,0,0,0,1.96-1.411,2.507,2.507,0,0,0,.173-1.4c-.055-.094-.185-.157-.381-.251l-.014-.007-.164-.08c-.216-.108-1.713-.848-1.991-.947a.735.735,0,0,0-.252-.049.564.564,0,0,0-.468.268l-.092.13a10.08,10.08,0,0,1-.689.905.556.556,0,0,1-.414.169.752.752,0,0,1-.288-.059l-.074-.03a7.346,7.346,0,0,1-2.271-1.416,8.959,8.959,0,0,1-1.62-2.016.455.455,0,0,1,.108-.61l.009-.011c.093-.119.183-.215.279-.316.053-.056.1-.11.155-.168l.016-.018a1.62,1.62,0,0,0,.308-.439.613.613,0,0,0-.043-.544c-.049-.1-.343-.817-.6-1.448l0-.011-.044-.107-.246-.6c-.194-.456-.336-.48-.637-.491l-.1,0C-71.314-1223.136-71.391-1223.14-71.474-1223.14Z"
                          transform="translate(77.71 1227.71)"
                          fill="#25d366"
                        />
                      </svg>
                    </a>
                    <a
                      href="#"
                      className="modal__content__user-details__header__networks__network"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20.009"
                        viewBox="0 0 20 20.009"
                      >
                        <path
                          d="M0,.961V19.047a.961.961,0,0,0,.961.961h9.693V12.283h-2.6V9.126h2.6V6.475a3.49,3.49,0,0,1,3.49-3.49h2.722V5.821H14.917a1.112,1.112,0,0,0-1.111,1.111V9.126h3.007L16.4,12.283H13.8v7.726h5.237A.961.961,0,0,0,20,19.047V.961A.961.961,0,0,0,19.039,0H.953A.959.959,0,0,0,0,.961Z"
                          fill="#3b5998"
                          className="grey-mode"
                        />
                      </svg>
                    </a>
                    <a
                      href="#"
                      className="modal__content__user-details__header__networks__network"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20,4H4A2,2,0,0,0,2.01,6L2,18a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V6A2.006,2.006,0,0,0,20,4Zm0,4-8,5L4,8V6l8,5,8-5Z"
                          fill="#005daa"
                          className="grey-mode"
                        />
                      </svg>
                    </a>
                    <a
                      href="#"
                      className="modal__content__user-details__header__networks__network disable"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20.049"
                        height="20.049"
                        viewBox="0 0 20.049 20.049"
                      >
                        <circle
                          className="grey-mode"
                          cx="10.024"
                          cy="10.024"
                          r="10.024"
                          fill="#08c"
                        />
                        <path
                          d="M100.412,107.636a.334.334,0,0,0-.329-.027l-10.772,5.014a.527.527,0,0,0,.012.96l9.931,4.325a.532.532,0,0,0,.743-.448l.561-9.529A.334.334,0,0,0,100.412,107.636Z"
                          transform="translate(-85.522 -103.365)"
                          fill="#e5e5e5"
                        />
                        <path
                          d="M171.631,115.676l.671,4.487,7.455-11.73Z"
                          transform="translate(-164.91 -104.186)"
                          fill="#b7bec5"
                        />
                        <path
                          d="M100.083,107.613l-10.772,5.014a.527.527,0,0,0,.012.96l2.919,1.271,8.127-7.244A.334.334,0,0,0,100.083,107.613Z"
                          transform="translate(-85.522 -103.369)"
                          fill="#fff"
                        />
                        <path
                          d="M189.659,116.354l-.887,3.808,7.456-11.73Z"
                          transform="translate(-181.38 -104.186)"
                          fill="#fff"
                        />
                        <path
                          d="M218.03,108.456a.328.328,0,0,0-.043-.024l-6.569,7.922,5.454,2.375a.532.532,0,0,0,.743-.448l.561-9.529A.334.334,0,0,0,218.03,108.456Z"
                          transform="translate(-203.139 -104.186)"
                          fill="#fff"
                        />
                      </svg>
                    </a>
                    <a
                      href="#"
                      className="modal__content__user-details__header__networks__network disable"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24.615"
                        height="20"
                        viewBox="0 0 24.615 20"
                      >
                        <path
                          className="grey-mode"
                          d="M24.615,50.368a10.521,10.521,0,0,1-2.908.8,5.018,5.018,0,0,0,2.22-2.789,10.085,10.085,0,0,1-3.2,1.222A5.046,5.046,0,0,0,12,53.048a5.2,5.2,0,0,0,.117,1.151,14.284,14.284,0,0,1-10.4-5.278,5.048,5.048,0,0,0,1.551,6.745,4.984,4.984,0,0,1-2.28-.622V55.1a5.07,5.07,0,0,0,4.043,4.958,5.037,5.037,0,0,1-1.323.166,4.462,4.462,0,0,1-.955-.086,5.094,5.094,0,0,0,4.715,3.515A10.14,10.14,0,0,1,1.208,65.8,9.453,9.453,0,0,1,0,65.735,14.207,14.207,0,0,0,7.742,68,14.264,14.264,0,0,0,22.1,53.64c0-.223-.008-.438-.018-.652A10.067,10.067,0,0,0,24.615,50.368Z"
                          transform="translate(0 -48)"
                          fill="#1da1f2"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
                <form action="" className="modal__content__form">
                  <div className="modal__content__form__group modal__content__form__group--col-2">
                    <label
                      className="modal__content__form__group__label"
                      htmlFor="modal__content__form__group__label--cpf"
                    >
                      CPF:
                    </label>
                    <div className="modal__content__form__group__input-line">
                      <InputMask
                        disabled={this.state.disabled}
                        mask="999.999.999-99"
                        ref={(input) => (this.cpf = input)}
                        type="text"
                        name="cpf"
                        className="modal__content__form__group__input"
                        id="modal__content__form__group__label--cpf"
                      />
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-2">
                    <label
                      className="modal__content__form__group__label"
                      htmlFor="modal__content__form__group__label--rg"
                    >
                      RG:
                    </label>
                    <div className="modal__content__form__group__input-line">
                      <InputMask
                        disabled={this.state.disabled}
                        mask="99.99.99.99-99"
                        type="text"
                        name="rg"
                        ref={(input) => (this.rg = input)}
                        className="modal__content__form__group__input"
                        id="modal__content__form__group__label--rg"
                      />
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-2">
                    <label
                      className="modal__content__form__group__label"
                      htmlFor="modal__content__form__group__label--nascimento"
                    >
                      Data de Nascimento:
                    </label>
                    <div className="modal__content__form__group__input-line">
                      <input
                        disabled={this.state.disabled}
                        ref={(input) => (this.nascimento = input)}
                        type="date"
                        name="nascimento"
                        className="modal__content__form__group__input"
                        id="modal__content__form__group__label--nascimento"
                      />
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-2">
                    <label
                      className="modal__content__form__group__label"
                      htmlFor="modal__content__form__group__label--codigo"
                    >
                      Código Externo:
                    </label>
                    <div className="modal__content__form__group__input-line">
                      <input
                        disabled={this.state.disabled}
                        type="text"
                        ref={(input) => (this.codigoexterno = input)}
                        name="codigoexterno"
                        className="modal__content__form__group__input"
                        id="modal__content__form__group__label--codigo"
                      />
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-5">
                    <label
                      className="modal__content__form__group__label"
                      htmlFor="modal__content__form__group__label--endereco"
                    >
                      Endereço:
                    </label>
                    <div className="modal__content__form__group__input-line">
                      <input
                        disabled={true}
                        ref={(input) => (this.endereco = input)}
                        type="text"
                        name="endereco"
                        className="modal__content__form__group__input"
                        id="modal__content__form__group__label--endereco"
                      />
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-1">
                    <label
                      className="modal__content__form__group__label"
                      htmlFor="modal__content__form__group__label--endnumero"
                    >
                      Número:
                    </label>
                    <div className="modal__content__form__group__input-line">
                      <input
                        disabled={this.state.disabled}
                        ref={(input) => (this.numberaddress = input)}
                        type="text"
                        name="numberaddress"
                        className="modal__content__form__group__input"
                        id="modal__content__form__group__label--endnumero"
                      />
                      <input
                        disabled={this.state.disabled}
                        ref={(input) => (this.cepassociationid = input)}
                        type="hidden"
                        name="cepassociationid"
                        className="modal__content__form__group__input"
                        id="modal__content__form__group__label--endnumero"
                      />
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-2">
                    <label
                      className="modal__content__form__group__label"
                      htmlFor="modal__content__form__group__label--cep"
                    >
                      CEP:
                    </label>
                    <div className="modal__content__form__group__input-line">
                      <InputMask
                        disabled={this.state.disabled}
                        onBlur={this.getCep.bind(this)}
                        mask="99999-999"
                        ref={(input) => (this.cep = input)}
                        type="text"
                        name="cep"
                        className="modal__content__form__group__input"
                        id="modal__content__form__group__label--cep"
                      />
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-4">
                    <label
                      className="modal__content__form__group__label"
                      htmlFor="modal__content__form__group__label--contatode"
                    >
                      Cidade:
                    </label>
                    <div className="modal__content__form__group__input-line">
                      <input
                        disabled={true}
                        ref={(input) => (this.cidade = input)}
                        type="text"
                        name="cidade"
                        className="modal__content__form__group__input"
                        id="modal__content__form__group__label--cidade"
                      />
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-1">
                    <label
                      className="modal__content__form__group__label"
                      htmlFor="modal__content__form__group__label--contatode"
                    >
                      UF:
                    </label>
                    <div className="modal__content__form__group__input-line">
                      <input
                        disabled={true}
                        ref={(input) => (this.estado = input)}
                        type="text"
                        name="estado"
                        className="modal__content__form__group__input"
                        id="modal__content__form__group__label--estado"
                      />
                    </div>
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-3">
                    <label
                      className="modal__content__form__group__label"
                      htmlFor="modal__content__form__group__label--empresa"
                    >
                      Empresa:
                    </label>
                    <Select
                      isDisabled={this.state.disabled}
                      onChange={this.SelectEmpresa.bind(this)}
                      value={this.state.empresaC}
                      id="empresa"
                      name="empresa"
                      isLoading={false}
                      isClearable={true}
                      isRtl={false}
                      className="modal__content__form__group__input"
                      // id="modal__content__form__group__label--empresa"
                      options={companys}
                    />
                  </div>

                  <div className="modal__content__form__group modal__content__form__group--col-5">
                    <a
                      onClick={(event) => this.ShowModalMaisCampos(event)}
                      className="modal__content__form__group__button modal__content__form__group__button--text"
                    >
                      <i className="material-icons">visibility_off</i>{" "}
                      Visualizar menos campos
                    </a>
                  </div>
                  {(() => {
                    if (this.state.disabled === true) {
                      return (
                        <div className="modal__content__form__group modal__content__form__group--col-2">
                          <a
                            onClick={this.ButtonEdit.bind(this, false, "edit")}
                            className="modal__content__form__group__button"
                          >
                            Editar
                          </a>
                        </div>
                      );
                    } else if (
                      this.state.disabled === false &&
                      this.state.module === "edit"
                    ) {
                      return (
                        <div className="modal__content__form__group modal__content__form__group--col-2">
                          <a
                            onClick={(event) =>
                              this.updateContact(
                                event,
                                this.state.contactid,
                                this.state.numberscontact,
                                InfoUsers.id,
                              )
                            }
                            className="modal__content__form__group__button"
                          >
                            Salvar alterações
                          </a>
                        </div>
                      );
                    } else {
                      return (
                        <div className="modal__content__form__group modal__content__form__group--col-2">
                          <a
                            onClick={(event) =>
                              this.InsertContact(
                                event,
                                this.state.numberscontact,
                                InfoUsers.id,
                              )
                            }
                            className="modal__content__form__group__button"
                          >
                            Adicionar
                          </a>
                        </div>
                      );
                    }
                  })()}
                  <div className="modal__content__form__group modal__content__form__group--col-1">
                    <a
                      onClick={(event) => this.CancelMaisCampos(event)}
                      className="modal__content__form__group__button modal__content__form__group__button--white"
                    >
                      Cancelar
                    </a>
                  </div>
                </form>
              </main>
            </div>
          </div>
        </div>
        <div
          className="modal micromodal-slide"
          id="modal__interacao-voz"
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal__overlay" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__interacao-voz__title"
            >
              <header className="modal__header">
                <Typography.H2 color={"blue-selected-4"} weight={700}>
                  Histórico de atendimento
                </Typography.H2>
                {/* <h2 className="modal__title" id="modal__interacao-voz__title">
                  Histórico de atendimento
                </h2> */}
                <button
                  className="modal__close"
                  aria-label="Close modal"
                  data-micromodal-close
                ></button>
              </header>
              <main
                className="modal__content"
                id="modal__interacao-voz__content"
              >
                <div className="interacoes-info">
                  <div className="interacoes-info__name">
                    <UserPhoto size="large" />
                    {/* <div className="interacoes-info__name__photo">
                      <img src={DEFAULT} alt="a" />
                    </div> */}
                    <div className="interacoes-info__call-info__phone">
                      <Typography.H4 color={"black"}>
                        {createJSON(this.state.cliente)}
                      </Typography.H4>
                      <Typography.H5 color={"gray-180"}>
                        {this.state.clientpdf}
                      </Typography.H5>
                    </div>
                  </div>
                  <div className="interacoes-info__call-info">
                    <div className="interacoes-info__call-info__date">
                      Atendimento - {this.state.datepdf}
                    </div>
                  </div>
                </div>
                <div className="interacoes-media-content">
                  <div className="bubble">
                    {this.state.history.length > 0 ? (
                      this.state.history.map((history) =>
                        (() => {
                          if (InfoUsers.permreproduce === true) {
                            return (
                              <div className="bubble-media">
                                {(() => {
                                  var url = history.messagem;
                                  var name = "Sem arquivo de áudio disponível";
                                  let format = "";
                                  if (url) {
                                    url = url.replace(
                                      "192.168.178.2",
                                      "\\" + history.particao,
                                    );
                                    var name = url.split("\\");
                                    name = name.pop();
                                    format = name.split(".")[1];
                                  }

                                  return (
                                    <>
                                      <div
                                        className="bubble-media__playerBar"
                                        style={{ height: "62px" }}
                                      >
                                        <Audio
                                          audio
                                          link={
                                            InfoUsers.permreproduce
                                              ? connection_platform.type_connect +
                                                "://" +
                                                ipcurrent +
                                                url
                                              : ""
                                          }
                                          showImg={true}
                                        />
                                        {/* <audio
                                          controls
                                          controlsList="nodownload"
                                        >
                                          <source
                                            src={
                                              connection_platform.type_connect +
                                              "://" +
                                              ipcurrent +
                                              url
                                            }
                                            type="audio/ogg"
                                          />
                                          <source
                                            src={
                                              connection_platform.type_connect +
                                              "://" +
                                              ipcurrent +
                                              url
                                            }
                                            type="audio/mpeg"
                                          />
                                          Your browser.
                                        </audio> */}
                                      </div>
                                      <div className="bubble-media__mediaInfo">
                                        <span className="bubble-media__fileName">
                                          <p className="bubble-media__text">
                                            {name}
                                          </p>
                                          <br />
                                          <div className="fileinfo__bar">
                                            <span className="fileinfo__size">
                                              FORMATO
                                            </span>{" "}
                                            •{" "}
                                            <span className="fileinfo__type">
                                              {format
                                                ? format.toLocaleUpperCase()
                                                : ""}
                                            </span>
                                          </div>
                                        </span>
                                        {(() => {
                                          if (
                                            InfoUsers.permdownload === true &&
                                            url
                                          ) {
                                            return (
                                              <span className="bubble-media__newdownload">
                                                <a
                                                  href={
                                                    connection_platform.type_connect +
                                                    "://" +
                                                    ipcurrent +
                                                    url
                                                  }
                                                  target="_blank"
                                                  download
                                                  className="bubble-media__btnDownload"
                                                >
                                                  {/* <i className="material-icons">
                                                    get_app
                                                  </i> */}
                                                  <IconDownload />
                                                </a>
                                              </span>
                                            );
                                          }
                                        })()}
                                      </div>
                                      <div className="bubble-media__progressbar-wrapper">
                                        <div className="bubble-media__progressbar-track">
                                          <div
                                            className="bubble-media__progressbar-bullet"
                                            style={{ width: "17%" }}
                                          ></div>
                                        </div>
                                        <span className="bubble-media__progressbar-counter ">
                                          17%
                                        </span>
                                      </div>
                                    </>
                                  );
                                })()}
                              </div>
                            );
                          }
                        })(),
                      )
                    ) : (
                      <Loading.Paperplane fullPage={true} />
                    )}
                  </div>
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>
    );
  }
  exportPDFWithMethod = () => {
    savePDF(ReactDOM.findDOMNode(this.pdfExportComponent), {
      paperSize: "A4",
      margin: 10,
      fileName: this.state.cliente + "_" + this.state.clientpdf + ".pdf",
    });
  };
  exportPDFWithComponent = () => {
    this.pdfExportComponent.save();
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Historic);
